import type { TranslationKeys } from './types';

export const ru: TranslationKeys = {
  // === Toolbar ===
  'toolbar.select': 'Выделение',
  'toolbar.draw': 'Рисование',
  'toolbar.erase': 'Ластик',
  'toolbar.shape': 'Фигуры',
  'toolbar.measure': 'Линейка',
  'toolbar.fog': 'Туман войны',
  'toolbar.note': 'Заметка',
  'toolbar.portal': 'Портал',
  'toolbar.selectDrawing': 'Выделение рисунков',
  'toolbar.text': 'Текст',
  'toolbar.aoe': 'АоЕ',
  'toolbar.mapObject': 'Объект',
  'toolbar.wall': 'Стены',
  'toolbar.token': 'Токен',
  'toolbar.token.helper': 'Перетащите персонажа из панели персонажей на карту',
  'toolbar.undo': 'Отменить',
  'toolbar.redo': 'Повторить',

  // === Toolbar Groups ===
  'toolbar.group.select': 'Выделение',
  'toolbar.group.drawing': 'Рисование',
  'toolbar.group.fog': 'Туман войны',
  'toolbar.group.measure': 'Линейка',
  'toolbar.group.pins': 'Пины карты',
  'toolbar.group.text': 'Текст',
  'toolbar.group.token': 'Токен',
  'toolbar.group.mapObjects': 'Объекты карты',
  'toolbar.group.note': 'Заметки',
  'toolbar.group.objects': 'Объекты',
  'toolbar.group.aiEdit': 'AI-редактирование',
  'toolbar.inpaintRect': 'Прямоугольное выделение',
  'toolbar.inpaintLasso': 'Лассо-выделение',
  'toolbar.detailRect': 'Детальная карта',
  'toolbar.initiative': 'Инициатива',
  'toolbar.held': 'удерж.',
  'toolbar.snapActive': 'Привязка',
  'toolbar.overflow': 'Ещё...',

  // === Canvas Context Menu ===
  'contextMenu.addToken': 'Добавить токен',
  'contextMenu.addPin': 'Добавить метку',
  'contextMenu.actAs': 'Действовать за',
  'contextMenu.addText': 'Добавить текст',
  'contextMenu.editToken': 'Редактировать токен',
  'contextMenu.deleteToken': 'Удалить токен',
  'contextMenu.copyToken': 'Копировать токен',
  'contextMenu.moveToFront': 'На передний план',
  'contextMenu.moveToBack': 'На задний план',
  'contextMenu.openEntry': 'Открыть запись',
  'contextMenu.movePin': 'Переместить метку',
  'contextMenu.deletePin': 'Удалить метку',
  'contextMenu.deleteDrawing': 'Удалить рисунок',
  'contextMenu.changeColor': 'Изменить цвет',
  'contextMenu.viewToken': 'Просмотр токена',

  // === Drawing Selection ===
  'drawingSelection.stroke': 'рисунок',
  'drawingSelection.strokes': 'рисунков',
  'drawingSelection.toolbar': 'Действия с выделенными рисунками',
  'drawingSelection.delete': 'Удалить',

  // === Sidebar Tabs ===
  'sidebar.map': 'Карта',
  'sidebar.journal': 'Журнал',
  'sidebar.notes': 'Заметки',
  'sidebar.chat': 'Чат',
  'sidebar.srd': 'SRD',
  'sidebar.initiative': 'Инициатива',
  'sidebar.participants': 'Участники',
  'sidebar.ai': 'AI',
  'sidebar.characters': 'Персонажи',

  // === Sidebar Sections (Map tab) ===
  'sidebar.section.pages': 'Страницы',
  'sidebar.section.tokens': 'Токены',
  'sidebar.section.pins': 'Метки',
  'sidebar.section.mapObjects': 'Объекты карты',

  // === Inspector ===
  'inspector.title': 'Инспектор',
  'inspector.empty': 'Выберите объект на карте',
  'inspector.tokenName': 'Имя',
  'inspector.tokenHp': 'HP',
  'inspector.tokenAc': 'AC',
  'inspector.tokenAuras': 'Ауры',
  'inspector.tokenDescription': 'Описание',
  'inspector.tokenVision': 'Видимость',
  'inspector.visionRange': 'Дальность',
  'inspector.darkvision': 'Тёмное зрение',
  'inspector.drawingColor': 'Цвет',
  'inspector.drawingWidth': 'Ширина',
  'inspector.deleteDrawing': 'Удалить рисунок',
  'inspector.textContent': 'Содержание',
  'inspector.textFontSize': 'Размер шрифта',
  'inspector.editText': 'Редактировать текст',
  'inspector.pinTitle': 'Заголовок',
  'inspector.pinVisibility': 'Видимость',
  'inspector.pinOpenEntry': 'Открыть запись',
  'inspector.mapObjectProps': 'Свойства',
  'inspector.locationTarget': 'Целевая страница',
  'inspector.locationNavigate': 'Перейти',
  'inspector.multiCount': '{count} объектов выделено',
  'inspector.multiDelete': 'Удалить все',
  'inspector.notFound': 'Объект не найден',
  'inspector.readOnly': 'Только просмотр',

  // === Common Actions ===
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.delete': 'Удалить',
  'common.create': 'Создать',
  'common.edit': 'Редактировать',
  'common.back': 'Назад',
  'common.close': 'Закрыть',
  'common.loading': 'Загрузка...',
  'common.search': 'Поиск',
  'common.reset': 'Сброс',
  'common.next': 'Далее',
  'common.confirm': 'Подтвердить',
  'common.name': 'Имя',
  'common.none': '— нет —',

  // === Auth ===
  'auth.login': 'Войти',
  'auth.loginTitle': 'Вход',
  'auth.loginBusy': 'Вход...',
  'auth.register': 'Регистрация',
  'auth.registerTitle': 'Регистрация',
  'auth.registerBusy': 'Регистрация...',
  'auth.registerSubmit': 'Зарегистрироваться',
  'auth.inviteCode': 'Код приглашения',
  'auth.inviteCodeHint': 'Код закрытой беты. Запросите у администратора.',
  'auth.inviteCodePlaceholder': 'Введите код приглашения',
  'auth.email': 'Email',
  'auth.password': 'Пароль',
  'auth.passwordHint': 'Пароль (от 8 символов)',
  'auth.displayName': 'Имя',
  'auth.hasAccount': 'Уже есть аккаунт? Войти',
  'auth.noAccount': 'Нет аккаунта? Зарегистрироваться',
  'auth.showPassword': 'Показать пароль',
  'auth.hidePassword': 'Скрыть пароль',
  'auth.profileTitle': 'Настройки профиля',
  'auth.displayNameLabel': 'Отображаемое имя:',
  'auth.saveBusy': 'Сохранение...',

  // === Lobby ===
  'lobby.createSession': 'Создать сессию',
  'lobby.joinSession': 'Присоединиться',
  'lobby.yourName': 'Ваше имя:',
  'lobby.sessionCode': 'Код сессии:',
  'lobby.connecting': 'Подключение...',
  'lobby.enter': 'Войти',

  // === Session List ===
  'sessionList.title': 'Ваши сессии',
  'sessionList.session': 'Сессия',
  'sessionList.player': 'Игрок',
  'sessionList.loading': 'Загрузка сессий...',
  'sessionList.copied': 'Скопировано!',
  'sessionList.copyCode': 'Скопировать код',
  'sessionList.today': 'Сегодня',
  'sessionList.yesterday': 'Вчера',
  'sessionList.daysAgo': 'назад',
  'sessionList.rename': 'Переименовать',
  'sessionList.delete': 'Удалить',
  'sessionList.copyInvite': 'Скопировать ссылку-приглашение',
  'sessionList.deleteConfirm': 'Вы уверены, что хотите удалить эту сессию?',
  'sessionList.deleteConfirmTitle': 'Удаление сессии',
  'sessionList.previewComingSoon': 'Скоро',
  'sessionList.inviteCopied': 'Ссылка-приглашение скопирована',

  // === Chat ===
  'chat.title': 'Чат',
  'chat.placeholder': 'Сообщение или /roll 2d6+3',
  'chat.rolls': ' бросает ',
  'chat.helpUsage': 'Использование: /roll 2d6+3',
  'chat.nameChanged': 'Имя изменено на:',
  'chat.helpRoll': '/roll NdX+M — бросок кубиков',
  'chat.helpName': '/name Имя — изменить имя',
  'chat.helpClear': '/clear — очистить чат',
  'chat.helpGm': '/gm текст — скрытое сообщение',
  'chat.unknownCommand': 'Неизвестная команда. /help для списка команд.',
  'chat.welcome': 'Добро пожаловать в VTT! /help в чате для списка команд.',
  'chat.welcomeShortcuts': 'Ctrl+S — сохранить сессию, Ctrl+L — загрузить',

  // === Initiative ===
  'initiative.title': 'Инициатива',
  'initiative.rollAll': 'Бросить инициативу',
  'initiative.next': 'Следующий ▶',
  'initiative.reset': 'Сброс',
  'initiative.roundStart': 'Инициатива (раунд 1):',
  'initiative.round': 'Раунд',
  'initiative.turn': '▶ Ход:',
  'initiative.otherPage': '(другая страница)',

  // === Tokens ===
  'tokens.title': 'Токены',
  'tokens.add': 'Добавить токен',
  'tokens.boundToSheet': 'Привязан к чар-листу',
  'tokens.sheetLabel': 'Чар-лист:',
  'tokens.tokenName': 'Имя токена:',
  'tokens.defaultName': 'Токен',
  'tokens.added': 'Токен добавлен:',
  'tokens.created': 'Токен создан:',

  // === Dice ===
  'dice.title': 'Кубики',
  'dice.roll': 'Бросить',

  // === Pages ===
  'pages.title': 'Страницы',
  'pages.uploadMap': 'Загрузить карту',
  'pages.clearDrawings': 'Очистить рисунки',
  'pages.aiMap': 'AI-карта',
  'pages.newPage': '+ Новая страница',
  'pages.pageNamePrompt': 'Имя новой страницы:',
  'pages.showToPlayers': 'Показать игрокам',
  'pages.preview': 'Просмотр (Preview)',
  'pages.moveUp': 'Вверх',
  'pages.moveDown': 'Вниз',
  'pages.doubleClickRename': 'Двойной клик для переименования',
  'pages.drawingsCleared': 'Рисунки очищены',
  'pages.deleteConfirmTitle': 'Удалить страницу?',
  'pages.deleteConfirmDesc': 'Все токены и рисунки на этой странице будут безвозвратно удалены.',
  'pages.deleteConfirmDescWithChildren': 'Все токены и рисунки будут удалены. Вложенные страницы переместятся в корень.',
  'pages.newChildPage': 'Добавить вложенную страницу',
  'pages.collapseAll': 'Свернуть все',
  'pages.expandAll': 'Развернуть все',
  'pages.childPageNamePrompt': 'Имя вложенной страницы:',

  // === Characters ===
  'characters.title': 'Персонажи',
  'characters.createWizard': 'Создать через визард (D&D 5e)',
  'characters.empty': 'Нет персонажей',
  'characters.create': '+ Создать персонажа',
  'characters.newCharacter': 'Новый персонаж',
  'characters.nameLabel': 'Имя:',
  'characters.namePlaceholder': 'Имя персонажа',
  'characters.templateLabel': 'Шаблон:',
  'characters.typeLabel': 'Тип:',
  'characters.typePC': 'PC (Игрок)',
  'characters.typeNPC': 'NPC',
  'characters.builtIn': '(встроенный)',
  'characters.foreignSheet': 'Чужой персонаж',
  'characters.performanceWarning': 'персонажей — производительность может снизиться',
  'characters.assignOwner': 'Назначить владельца',
  'characters.assignOwnerDescription': 'Выберите игрока — владельца персонажа:',
  'characters.publicFields': 'Публичные поля (что видно партии)',
  'characters.sheetVisibleTitle': 'Лист виден игрокам — скрыть',
  'characters.sheetHiddenTitle': 'Лист скрыт от игроков — показать',
  'characters.cardVisibilityTitle': 'Карточка на сцене',
  'characters.publicFieldsDescription': 'Поля, которые видят другие игроки:',
  'characters.noOwner': 'Без владельца',
  'characters.createWithoutOwner': 'Без владельца',
  'characters.createAndAssign': 'Назначить',
  'characters.ungrouped': 'Без группы',
  'characters.newGroup': 'Новая группа',
  'characters.groupName': 'Название группы',
  'characters.deleteGroup': 'Удалить группу',
  'characters.renameGroup': 'Переименовать группу',

  // === Participants ===
  'participants.title': 'Участники',

  // === Notes ===
  'notes.title': 'Заметки на карте',
  'notes.empty': 'Нет заметок. Используйте инструмент заметок для создания.',
  'notes.untitled': 'Без названия',
  'notes.gmOnly': 'только GM',
  'notes.newNote': 'Новая заметка',
  'notes.editNote': 'Редактировать заметку',
  'notes.noteTitle': 'Название',
  'notes.noteContent': 'Содержимое',
  'notes.icon': 'Иконка',
  'notes.color': 'Цвет',
  'notes.selectColor': 'Выбрать цвет',

  // === Note icons ===
  'noteIcon.pin': 'Булавка',
  'noteIcon.scroll': 'Свиток',
  'noteIcon.skull': 'Череп',
  'noteIcon.chest': 'Сундук',
  'noteIcon.star': 'Звезда',
  'noteIcon.question': 'Вопрос',
  'noteIcon.exclamation': 'Внимание',
  'noteIcon.camp': 'Лагерь',
  'noteIcon.sword': 'Бой',
  'noteIcon.key': 'Ключ',

  // === Reconnect ===
  'reconnect.message': 'Переподключение...',

  // === Connection Status ===
  'status.online': '● Онлайн',
  'status.reconnecting': '◌ Переподключение...',

  // === Workspace Presets ===
  'preset.explore': 'Исследование (Alt+1)',
  'preset.combat': 'Бой (Alt+2)',
  'preset.prep': 'Подготовка (Alt+3)',
  'preset.fullscreen': 'Полноэкранный режим',
  'preset.exit': 'Выйти',

  // === Shortcuts ===
  'shortcuts.title': 'Горячие клавиши',
  'shortcuts.hint': 'Горячие клавиши не срабатывают, когда фокус находится в поле ввода.',
  'shortcuts.sectionTools': 'Инструменты',
  'shortcuts.sectionCamera': 'Камера',
  'shortcuts.sectionTokens': 'Токены',
  'shortcuts.sectionChat': 'Чат и инициатива',
  'shortcuts.sectionWorkspace': 'Рабочее пространство',
  'shortcuts.toolSelect': 'Инструмент: Выделение',
  'shortcuts.toolDraw': 'Инструмент: Рисование',
  'shortcuts.toolEraser': 'Инструмент: Ластик',
  'shortcuts.toolRuler': 'Инструмент: Линейка',
  'shortcuts.toolFog': 'Инструмент: Туман войны',
  'shortcuts.toolNote': 'Инструмент: Заметка (GM)',
  'shortcuts.toolPortal': 'Инструмент: Портал (GM)',
  'shortcuts.snapToggle': 'Привязка к сетке (вкл/выкл)',
  'shortcuts.zoomIn': 'Увеличить масштаб',
  'shortcuts.zoomOut': 'Уменьшить масштаб',
  'shortcuts.fitToScreen': 'По размеру экрана',
  'shortcuts.exitFullscreen': 'Выход из полноэкранного режима',
  'shortcuts.deleteTokens': 'Удалить выделенные токены',
  'shortcuts.quickSelectToken': 'Быстро выделить токен по номеру',
  'shortcuts.nextTurn': 'Следующий ход инициативы',
  'shortcuts.openMapPanel': 'Открыть панель карты',
  'shortcuts.presetExplore': 'Пресет: Исследование (GM)',
  'shortcuts.presetCombat': 'Пресет: Бой (GM)',
  'shortcuts.presetPrep': 'Пресет: Подготовка (GM)',
  'shortcuts.toggleSidebar': 'Свернуть/развернуть боковую панель',
  'shortcuts.showShortcuts': 'Показать/скрыть список горячих клавиш',
  'shortcuts.saveSession': 'Сохранить сессию',
  'shortcuts.loadSession': 'Загрузить сессию',
  'shortcuts.undo': 'Отменить',
  'shortcuts.redo': 'Повторить',
  'shortcuts.toolSelectDrawing': 'Инструмент: Выделение рисунков (GM)',
  'shortcuts.toolText': 'Инструмент: Текст (GM)',
  'shortcuts.toolAoe': 'Инструмент: АоЕ (GM)',
  'shortcuts.toolMapObject': 'Инструмент: Объект (GM)',
  'shortcuts.fogBrushDec': 'Кисть тумана: уменьшить',
  'shortcuts.fogBrushInc': 'Кисть тумана: увеличить',
  'shortcuts.copy': 'Копировать токен',
  'shortcuts.paste': 'Вставить токен',
  'shortcuts.toggleInspector': 'Переключить инспектор (Ctrl+I)',
  'shortcuts.toggleInitiative': 'Переключить инициативу (I)',

  // === Tool Options ===
  'toolOptions.snapToGrid': 'Привязка к сетке',
  'toolOptions.color': 'Цвет:',
  'toolOptions.width': 'Толщина:',
  'toolOptions.mode': 'Режим:',
  'toolOptions.modeSimple': 'Простой',
  'toolOptions.modeAlternating': 'Чередующийся (D&D)',
  'toolOptions.modeEuclidean': 'Евклидов',
  'toolOptions.modeHex': 'Гекс',
  'toolOptions.gridSizeFt': 'Клетка (фт):',
  'toolOptions.shape': 'Форма:',
  'toolOptions.shapeRect': 'Прямоугольник',
  'toolOptions.shapePolygon': 'Полигон',
  'toolOptions.shapeCircle': 'Круг',
  'toolOptions.navigation': 'Навигация:',
  'toolOptions.navFree': 'Свободный',
  'toolOptions.navConfirm': 'Подтверждение',
  'toolOptions.navGmOnly': 'Только GM',
  'toolOptions.reFog': 'Закрыть туман',
  'toolOptions.dynamicFogHint': 'Динамический туман: закрытие управляется зрением токенов',
  'toolOptions.clearAllFog': 'Убрать всё',
  'toolOptions.coverAllFog': 'Покрыть всё',
  'toolOptions.shapeLine': 'Линия',
  'toolOptions.fogMode': 'Режим:',
  'toolOptions.brushSize': 'Кисть:',
  'toolOptions.mapSettings': 'Настройки карты',
  'toolOptions.gridSize': 'Размер сетки:',
  'toolOptions.mapScale': 'Масштаб карты:',
  'toolOptions.bgColor': 'Фон:',
  'toolOptions.deleteMap': 'Удалить карту',
  'toolOptions.confirmDeleteMap': 'Удалить карту?',
  'toolOptions.fogSystem': 'Система:',
  'toolOptions.fogManual': 'Ручной',
  'toolOptions.fogDynamic': 'Динамический',
  'toolOptions.wallType': 'Тип:',
  'toolOptions.wallTypeWall': 'Стена',
  'toolOptions.wallTypeDoor': 'Дверь',
  'toolOptions.wallTypeWindow': 'Окно',
  'toolOptions.wallTypeTerrain': 'Рельеф',
  'toolOptions.wallTypeSecret': 'Тайная',
  'toolOptions.wallTypeEthereal': 'Эфирная',
  'toolOptions.aiEditMode': 'Режим',
  'toolOptions.sketchToMap': 'Карта из скетча',

  // === Token Edit Dialog ===
  'tokenEdit.title': 'Редактирование токена',
  'tokenEdit.name': 'Имя:',
  'tokenEdit.size': 'Размер:',
  'tokenEdit.sizeTiny': 'Крошечный (½)',
  'tokenEdit.sizeMedium': 'Средний (1)',
  'tokenEdit.sizeLarge': 'Большой (2)',
  'tokenEdit.sizeHuge': 'Огромный (3)',
  'tokenEdit.sizeGargantuan': 'Гигантский (4)',
  'tokenEdit.color': 'Цвет:',
  'tokenEdit.notes': 'Заметки:',
  'tokenEdit.visible': 'Виден игрокам',
  'tokenEdit.light': 'Свет',
  'tokenEdit.lightEnabled': 'Излучает свет',
  'tokenEdit.lightBright': 'Радиус яркого света',
  'tokenEdit.lightDim': 'Радиус тусклого света',
  'tokenEdit.lightColor': 'Цвет света',
  'tokenEdit.visionType': 'Тип зрения',
  'tokenEdit.visionTypeNormal': 'Обычное',
  'tokenEdit.visionTypeDarkvision': 'Тёмное зрение',

  // === Global Illumination ===
  'page.globalIllumination': 'Освещение',
  'page.illuminationBright': 'Яркий свет',
  'page.illuminationDim': 'Тусклый свет',
  'page.illuminationDark': 'Полная тьма',
  'page.illuminationColor': 'Цвет освещения',

  // === Conditions Dialog ===
  'conditions.title': 'Состояния',

  // === Context Menu ===
  'contextMenu.inspect': 'Описание',
  'contextMenu.edit': 'Редактировать',
  'contextMenu.conditions': 'Состояния',
  'contextMenu.hp': 'HP',
  'contextMenu.resize': 'Размер',
  'contextMenu.addAura': 'Добавить ауру',
  'contextMenu.layerUp': 'Наверх',
  'contextMenu.layerDown': 'Вниз',
  'contextMenu.copy': 'Копировать',
  'contextMenu.delete': 'Удалить',
  'contextMenu.auras': 'Ауры:',
  'contextMenu.fogReset': 'Сбросить туман войны',
  'contextMenu.hideToken': 'Скрыть от игроков',
  'contextMenu.showToken': 'Показать игрокам',
  'contextMenu.enableVision': 'Включить видимость',
  'contextMenu.disableVision': 'Выключить видимость',
  'contextMenu.openSheet': 'Открыть лист',

  // === Link Context Menu ===
  'linkMenu.edit': 'Редактировать',
  'linkMenu.navigate': 'Перейти к целевой',
  'linkMenu.toggleVisibility': 'Скрыть/Показать',
  'linkMenu.delete': 'Удалить',
  'linkMenu.zone': 'Зона',

  // === Aura Editor ===
  'aura.editTitle': 'Редактировать ауру',
  'aura.addTitle': 'Добавить ауру',
  'aura.radiusFt': 'Радиус (фт):',
  'aura.color': 'Цвет:',
  'aura.opacity': 'Прозрачность:',
  'aura.label': 'Название:',
  'aura.style': 'Стиль:',
  'aura.styleSolid': 'Сплошной',
  'aura.styleDashed': 'Пунктир',
  'aura.stylePulse': 'Пульсация',
  'aura.gmOnly': 'Только для GM',

  // === Location Link Dialog ===
  'locationLink.editTitle': 'Редактировать зону',
  'locationLink.createTitle': 'Создать зону-портал',
  'locationLink.targetPage': 'Целевая страница',
  'locationLink.selectPage': 'Выберите страницу…',
  'locationLink.label': 'Название',
  'locationLink.labelPlaceholder': 'Название зоны…',
  'locationLink.style': 'Стиль',
  'locationLink.stylePortal': 'Портал',
  'locationLink.styleDoor': 'Дверь',
  'locationLink.styleStairs': 'Лестница',
  'locationLink.styleArea': 'Область',

  // === Template Editor ===
  'templates.title': 'Шаблоны',
  'templates.builtIn': '(встр.)',
  'templates.createTemplate': '+ Создать шаблон',
  'templates.editTemplate': 'Редактирование шаблона',
  'templates.newTemplate': 'Новый шаблон',
  'templates.nameLabel': 'Название:',
  'templates.newSection': 'Новая секция',
  'templates.newField': 'Новое поле',
  'templates.addField': '+ Поле',
  'templates.addSection': '+ Секция',
  'templates.deleteSection': 'Удалить секцию',

  // === AI Chat ===
  'ai.title': 'Тиа Сильверфолл',
  'ai.newChat': 'Новый чат',
  'ai.emptyHint': 'Тиа собирает истории. Расскажите ей свою.',
  'ai.thinking': 'Тиа думает...',
  'ai.placeholder': 'Спросите Тиа...',
  'ai.modeSuggest': 'Совет',
  'ai.textModel': 'Текстовая модель',
  'ai.imageModel': 'Модель картинок',
  'aiModel.mapModel': 'Модель для карты',
  'settings.aiTextModel': 'Текстовая модель ассистента по умолчанию',
  'settings.aiTextModelServer': 'По умолчанию сервера',
  'ai.modeDraft': 'Черновик',
  'ai.modeAuto': 'Авто',
  'ai.undo': 'Отменить',
  'ai.thinkingLabel': 'Размышления',
  'ai.stop': 'Остановить генерацию',
  'ai.conversationHistory': 'История чатов',
  'ai.noConversations': 'Нет предыдущих бесед',
  'ai.loadingHistory': 'Загрузка истории...',
  'ai.toolErrorFriendly': 'Не удалось выполнить операцию',
  'ai.stoppedByGM': 'Генерация остановлена мастером.',
  'ai.openThinkingModal': 'Открыть полный ход мыслей',
  'ai.skillApprove': 'Одобрить',
  'ai.skillReject': 'Отклонить',
  'ai.skillRejectConfirm': 'Отклонить план',
  'ai.skillApproved': 'План одобрен',
  'ai.skillRejected': 'План отклонён',
  'ai.skillAutoExecuting': 'Выполняется автоматически...',
  'ai.skillAutoCompleted': 'Выполнено автоматически',
  'ai.skillFeedbackPlaceholder': 'Комментарий для ИИ...',
  'ai.skillAddFeedback': 'Добавить комментарий',
  'ai.emptyTiaGreeting': 'Привет! Я Тиа Сильверфолл. Чем могу помочь с вашим приключением?',
  'ai.emptyPersonaGreeting': 'Привет! Я {name}. Задайте мне вопрос.',
  'ai.personaMemory': 'Память персоны',
  'ai.chronicle': 'Летопись',
  'ai.generating': 'Генерация...',
  'ai.saveAsJournal': 'Сохранить как запись журнала',
  'ai.noPersonaMemory': 'Пока нет воспоминаний. Тиа сформирует впечатления после разговоров.',
  'ai.requestChronicle': 'Запросить летопись',
  'ai.requestEpilogue': 'Эпилог',

  // === AI Tool Labels ===
  'aiTool.getSessionInfo': 'Получение информации о сессии',
  'aiTool.getCurrentPage': 'Просмотр текущей страницы',
  'aiTool.listSheets': 'Список листов персонажей',
  'aiTool.getSheet': 'Просмотр листа персонажа',
  'aiTool.createNote': 'Создание заметки',
  'aiTool.searchMonsters': 'Поиск монстров в SRD',
  'aiTool.getMonster': 'Получение стат-блока монстра',
  'aiTool.searchClasses': 'Поиск классов в SRD',
  'aiTool.searchSpells': 'Поиск заклинаний в SRD',
  'aiTool.createSheet': 'Создание листа персонажа',
  'aiTool.updateSheet': 'Обновление листа персонажа',
  'aiTool.createToken': 'Создание токена',
  'aiTool.bindSheet': 'Привязка листа к токену',
  'aiTool.createNpc': 'Создание NPC (лист + токен)',
  'aiTool.initiativeUpdate': 'Установка инициативы',
  'aiTool.initiativeNext': 'Следующий ход',
  'aiTool.initiativeReset': 'Сброс инициативы',
  'aiTool.applyDamage': 'Нанесение урона',
  'aiTool.applyHealing': 'Лечение',
  'aiTool.spellSlotSpend': 'Трата ячейки заклинания',
  'aiTool.concentrationSet': 'Установка концентрации',
  'aiTool.effectAdd': 'Добавление эффекта',
  'aiTool.effectUpdate': 'Обновление эффекта',
  'aiTool.effectRemove': 'Удаление эффекта',
  'aiTool.repeatingRowAdd': 'Добавление строки',
  'aiTool.repeatingRowUpdate': 'Обновление строки',
  'aiTool.repeatingRowRemove': 'Удаление строки',
  'aiTool.pageActivate': 'Переключение страницы',
  'aiTool.pageTransfer': 'Перенос токенов',
  'aiTool.pageCreate': 'Создание страницы',
  'aiTool.pageRename': 'Переименование страницы',
  'aiTool.locationLinkCreate': 'Создание ссылки-локации',
  'aiTool.fogReveal': 'Раскрытие тумана войны',
  'aiTool.fogReset': 'Сброс тумана войны',
  'aiTool.fogToggle': 'Переключение тумана войны',
  'aiTool.sheetRest': 'Отдых',
  'aiTool.abilityAdd': 'Добавление способности',
  'aiTool.abilityRemove': 'Удаление способности',
  'aiTool.spellbookAdd': 'Добавление заклинания',
  'aiTool.spellbookRemove': 'Удаление заклинания',
  'aiTool.tokenMove': 'Перемещение токена',
  'aiTool.tokenUpdate': 'Обновление токена',
  'aiTool.tokenDelete': 'Удаление токена',
  'aiTool.chatMessage': 'Отправка сообщения',
  'aiTool.chatRoll': 'Бросок кубиков',
  'aiTool.rulerShow': 'Показ линейки',
  'aiTool.searchJournal': 'Поиск в журнале',
  'aiTool.getJournalEntry': 'Чтение записи журнала',
  'aiTool.getRelatedEntries': 'Поиск связанных записей',
  'aiTool.createJournalEntry': 'Создание записи журнала',
  'aiTool.updateJournalEntry': 'Обновление записи журнала',
  'aiTool.revealJournalEntry': 'Раскрытие записи журнала',
  'aiTool.journalLink': 'Связывание записей журнала',
  'aiTool.getSpell': 'Просмотр заклинания',
  'aiTool.searchEquipment': 'Поиск снаряжения',
  'aiTool.searchMagicItems': 'Поиск магических предметов',
  'aiTool.searchRaces': 'Поиск рас',
  'aiTool.searchConditions': 'Поиск состояний',
  'aiTool.createTimelineEvents': 'Генерация событий таймлайна',
  'aiTool.generateCalendar': 'Генерация календаря',

  // === Timeline Batch Preview (054) ===
  'timelineBatch.title': 'Просмотр событий от AI',
  'timelineBatch.selectAll': 'Выбрать все',
  'timelineBatch.deselectAll': 'Снять все',
  'timelineBatch.selected': 'Выбрано',
  'timelineBatch.confirm': 'Подтвердить',
  'timelineBatch.cancel': 'Отмена',
  'timelineBatch.titlePlaceholder': 'Заголовок события',
  'timelineBatch.reviewButton': 'Просмотреть события',

  // === Calendar AI Tab (054) ===
  'calendarAi.unavailable': 'AI-генерация недоступна',
  'calendarAi.worldDescription': 'Описание мира',
  'calendarAi.worldPlaceholder': 'Опишите мир: сеттинг, сезоны, особенности...',
  'calendarAi.minChars': 'Мин. 10 символов',
  'calendarAi.generating': 'Генерация...',
  'calendarAi.generate': 'Сгенерировать календарь',
  'calendarAi.preview': 'Предпросмотр календаря',
  'calendarAi.calendarName': 'Название',
  'calendarAi.yearLabel': 'Лейбл года',
  'calendarAi.epoch': 'Эпоха',
  'calendarAi.months': 'Месяцы',
  'calendarAi.accept': 'Принять',
  'calendarAi.regenerate': 'Перегенерировать',
  'calendarAi.replaceTitle': 'Заменить календарь?',
  'calendarAi.replaceWarning': 'Текущий календарь будет заменён. Это действие нельзя отменить.',
  'calendarAi.replaceConfirm': 'Заменить',

  // === Timeline Link Picker (054) ===
  'linkPicker.add': 'Добавить ссылку',
  'linkPicker.search': 'Поиск...',
  'linkPicker.remove': 'Удалить',
  'linkPicker.limitReached': 'Достигнут лимит ссылок',
  'linkPicker.journal': 'Журнал',
  'linkPicker.characters': 'Персонажи',
  'linkPicker.pins': 'Пины карты',
  'linkPicker.noResults': 'Ничего не найдено',

  // === AI Map Dialog ===
  'aiMap.title': 'AI-генерация карты',
  'aiMap.description': 'Введите промпт для генерации карты. Можно нарисовать скетч для более точного результата.',
  'aiMap.promptLabel': 'Промпт',
  'aiMap.placeholder': 'Опишите карту: \'Подземелье с длинными коридорами и тремя комнатами\'',
  'aiMap.noStrokesHint': 'Без скетча карта будет сгенерирована только по тексту.',
  'aiMap.errorGeneration': 'Ошибка генерации',
  'aiMap.errorNetwork': 'Ошибка сети. Попробуйте снова.',
  'aiMap.generating': 'Генерация карты... Это может занять до 2 минут.',
  'aiMap.preview': 'Превью',
  'aiMap.regenerate': 'Перегенерировать',
  'aiMap.accept': 'Принять',
  'aiMap.generate': 'Сгенерировать карту',
  'aiMap.altText': 'Сгенерированная карта',

  // === AI Inpainting ===
  'inpaint.promptPlaceholder': 'Опишите что должно появиться в выделенной области...',
  'inpaint.generate': 'Сгенерировать',
  'inpaint.accept': 'Принять',
  'inpaint.regenerate': 'Перегенерировать',
  'inpaint.cancel': 'Отмена',
  'inpaint.generating': 'Генерация...',
  'inpaint.tooSmall': 'Область слишком маленькая для inpainting',
  'inpaint.tooLarge': 'Для замены всей карты используйте генерацию',
  'inpaint.errorGeneration': 'Ошибка генерации inpainting',
  'inpaint.errorNetwork': 'Ошибка сети',

  // === AI Outpainting ===
  'outpaint.title': 'Расширить карту',
  'outpaint.directionTop': 'Вверх',
  'outpaint.directionRight': 'Вправо',
  'outpaint.directionBottom': 'Вниз',
  'outpaint.directionLeft': 'Влево',
  'outpaint.expandSize': 'Размер расширения',
  'outpaint.overlap': 'Перекрытие',
  'outpaint.prompt': 'Что нарисовать в расширенной области',
  'outpaint.generate': 'Генерировать',
  'outpaint.regenerate': 'Перегенерировать',
  'outpaint.accept': 'Принять',
  'outpaint.cancel': 'Отмена',
  'outpaint.generating': 'Генерация...',
  'outpaint.sizeWarning': 'Результат превысит 4096px',
  'outpaint.errorGeneration': 'Ошибка генерации',
  'outpaint.errorNetwork': 'Ошибка сети',
  'outpaint.noMap': 'Загрузите карту перед расширением',
  'outpaint.expandMap': 'Расширить карту',

  // === AI Detail Pass ===
  'detail.dialogTitle': 'Генерация детальной карты',
  'detail.cropLabel': 'Фрагмент карты',
  'detail.semanticLabel': 'Описание фрагмента (авто)',
  'detail.promptPlaceholder': 'Опишите, что должно быть на детальной карте...',
  'detail.generate': 'Сгенерировать',
  'detail.accept': 'Принять',
  'detail.regenerate': 'Перегенерировать',
  'detail.cancel': 'Отмена',
  'detail.existingLink': 'Для этой области уже есть карта: {name}',
  'detail.createNew': 'Создать новую',
  'detail.regenerateExisting': 'Перегенерировать существующую',
  'detail.errorSmallRegion': 'Область слишком маленькая (минимум 64×64)',
  'detail.errorNoMap': 'На странице нет карты',
  'detail.generating': 'Генерация...',
  'detail.accepting': 'Создание страницы...',

  // === SRD Panel ===
  'srd.title': 'SRD',
  'srd.monsters': 'Монстры',
  'srd.spells': 'Заклинания',
  'srd.classes': 'Классы',
  'srd.races': 'Расы',
  'srd.equipment': 'Снаряжение',
  'srd.magicItems': 'Маг. предметы',
  'srd.conditions': 'Состояния',
  'srd.searchPlaceholder': 'Поиск...',
  'srd.loading': 'Загрузка...',
  'srd.results': 'результатов',
  'srd.noResults': 'Ничего не найдено',
  'srd.loadMore': 'Загрузить ещё',
  'srd.back': 'Назад',
  'srd.allCR': 'Все CR',
  'srd.allTypes': 'Все типы',
  'srd.allLevels': 'Все уровни',
  'srd.cantrip': 'Заговор',
  'srd.level': 'Ур.',
  'srd.concentrationAbbr': 'К',
  'srd.allSchools': 'Все школы',
  'srd.allClasses': 'Все классы',
  'srd.allCategories': 'Все категории',
  'srd.allRarities': 'Все редкости',
  'srd.noFeaturesAtLevel': 'Нет новых фич на этом уровне',
  'srd.token': 'Токен',
  'srd.plusSheet': '+ Лист',

  // === Journal ===
  'journal.empty': 'Нет персонажей. Создайте во вкладке «Карта».',
  'journal.pcGroup': 'Персонажи игроков',
  'journal.npcGroup': 'NPC',
  // Journal panel
  'journal.panel.title': 'Журнал',
  'journal.panel.createEntry': 'Создать запись',
  'journal.panel.allTypes': 'Все типы',
  'journal.panel.searchPlaceholder': 'Поиск…',
  'journal.panel.noEntries': 'Записей нет',
  'journal.panel.noEntriesHint': 'Нажмите «+» чтобы создать первую запись',
  'journal.panel.noResults': 'Ничего не найдено',
  // Journal types
  'journal.type.npc': 'NPC',
  'journal.type.location': 'Локация',
  'journal.type.quest': 'Квест',
  'journal.type.faction': 'Фракция',
  'journal.type.handout': 'Раздатка',
  'journal.type.lore': 'Лор',
  // Journal sections (player view)
  'journal.section.quests': 'Квесты',
  'journal.section.myNotes': 'Мои заметки',
  'journal.section.knowledge': 'Знания',
  'journal.section.onThisMap': 'На этой карте',
  // Journal groups
  'journal.group.ungrouped': 'Без группы',
  'journal.group.new': 'Новая группа',
  'journal.group.namePlaceholder': 'Название группы',
  'journal.group.delete': 'Удалить группу',
  'journal.group.rename': 'Переименовать группу',
  // Journal visibility
  'journal.visibility.gm': 'Только ГМ',
  'journal.visibility.personal': 'Личное',
  'journal.visibility.all': 'Все',
  // Journal context menu
  'journal.menu.edit': 'Редактировать',
  'journal.menu.reveal': 'Показать игрокам',
  'journal.menu.pin': 'Закрепить',
  'journal.menu.unpin': 'Открепить',
  'journal.menu.delete': 'Удалить',
  // Journal delete dialog
  'journal.delete.title': 'Удалить запись?',
  'journal.delete.description': 'Это действие нельзя отменить. Запись будет удалена навсегда.',
  'journal.delete.cancel': 'Отмена',
  'journal.delete.confirm': 'Удалить',
  // Journal create dialog
  'journal.create.title': 'Новая запись',
  'journal.create.namePlaceholder': 'Название записи…',
  'journal.create.submit': 'Создать',
  // Journal preview fields
  'journal.preview.race': 'Раса',
  'journal.preview.occupation': 'Занятие',
  'journal.preview.disposition': 'Отношение',
  'journal.preview.description': 'Описание',
  'journal.preview.secrets': 'Секреты',
  'journal.preview.personality': 'Характер',
  'journal.preview.questHooks': 'Зацепки',
  'journal.preview.alive': 'Жив',
  'journal.preview.dead': 'Мёртв',
  'journal.preview.objectives': 'Цели',
  'journal.preview.gmNotes': 'Заметки ГМ',
  'journal.preview.rewards': 'Награды',
  'journal.preview.attitude': 'Отношение',
  'journal.preview.content': 'Содержание',
  'journal.preview.category': 'Категория',
  // Journal disposition
  'journal.disposition.friendly': 'Дружелюбный',
  'journal.disposition.neutral': 'Нейтральный',
  'journal.disposition.hostile': 'Враждебный',
  'journal.disposition.unknown': 'Неизвестно',

  // Journal editor
  'journal.editor.namePlaceholder': 'Название записи',
  'journal.editor.gmOnly': 'Только для GM',
  'journal.editor.reveal': 'Раскрыть игрокам',
  'journal.editor.revealedFields': 'Видимость полей',
  'journal.editor.revealedFieldsHint': 'Отметьте поля, видимые игрокам',
  'journal.editor.revealConfirm': 'Раскрыть "{name}" игрокам? Игроки получат уведомление.',
  'journal.editor.revealConfirmAction': 'Раскрыть',
  'journal.editor.pin': 'Закрепить',
  'journal.editor.unpin': 'Открепить',
  'journal.editor.openEditor': 'Открыть в редакторе',
  'journal.editor.visibilityGm': 'Только GM',
  'journal.editor.visibilityAll': 'Все игроки',
  'journal.editor.tags': 'Теги',
  'journal.editor.tagsPlaceholder': 'Добавить тег...',
  'journal.editor.addItem': 'Добавить',
  'journal.editor.removeItem': 'Удалить',
  'journal.editor.edit': 'Редактировать',
  'journal.editor.done': 'Готово',
  'journal.editor.more': 'Ещё',
  'journal.editor.bindToPin': 'Привязать к пину',
  'journal.editor.bindToSheet': 'Привязать чарлист',
  'journal.editor.bindToPage': 'Привязать к карте',
  'journal.editor.configureFields': 'Настроить видимые поля',
  'journal.editor.noContent': 'Нет содержания',

  // Journal form: NPC
  'journal.form.npc.portrait': 'Портрет (URL)',
  'journal.form.npc.race': 'Раса',
  'journal.form.npc.occupation': 'Род занятий',
  'journal.form.npc.disposition': 'Отношение',
  'journal.form.npc.description': 'Описание',
  'journal.form.npc.personality': 'Характер',
  'journal.form.npc.secrets': 'Секреты',
  'journal.form.npc.questHooks': 'Зацепки квестов',
  'journal.form.npc.alive': 'Жив',

  // Journal form: Location
  'journal.form.location.image': 'Изображение (URL)',
  'journal.form.location.parent': 'Родительская локация',
  'journal.form.location.description': 'Описание',
  'journal.form.location.secrets': 'Секреты',
  'journal.form.location.page': 'Страница карты',

  // Journal form: Quest
  'journal.form.quest.status': 'Статус',
  'journal.form.quest.questGiver': 'Квестодатель',
  'journal.form.quest.description': 'Описание',
  'journal.form.quest.gmNotes': 'Заметки GM',
  'journal.form.quest.objectives': 'Цели',
  'journal.form.quest.objectiveText': 'Текст цели',
  'journal.form.quest.objectiveCompleted': 'Выполнена',
  'journal.form.quest.objectiveHidden': 'Скрыта',
  'journal.form.quest.rewards': 'Награды',

  // Journal form: Faction
  'journal.form.faction.description': 'Описание',
  'journal.form.faction.attitude': 'Отношение',
  'journal.form.faction.secrets': 'Секреты',

  // Journal form: Handout
  'journal.form.handout.content': 'Содержание',
  'journal.form.handout.image': 'Изображение (URL)',
  'journal.form.handout.gmNotes': 'Заметки GM',

  // Journal form: Lore
  'journal.form.lore.category': 'Категория',
  'journal.form.lore.content': 'Содержание',

  // Journal form: Disposition options
  'journal.form.disposition.friendly': 'Дружелюбный',
  'journal.form.disposition.neutral': 'Нейтральный',
  'journal.form.disposition.hostile': 'Враждебный',
  'journal.form.disposition.unknown': 'Неизвестно',

  // Journal form: Quest status options
  'journal.form.questStatus.active': 'Активный',
  'journal.form.questStatus.completed': 'Завершён',
  'journal.form.questStatus.failed': 'Провален',
  'journal.form.questStatus.hidden': 'Скрытый',

  // Journal: Links
  'journal.links.title': 'Связи',
  'journal.links.add': 'Добавить',
  'journal.links.empty': 'Нет связей. Нажмите + чтобы добавить.',
  'journal.links.relation': 'Отношение',
  'journal.links.target': 'Целевая запись',
  'journal.links.customRelation': 'Произвольное',
  'journal.links.remove': 'Удалить связь',
  'journal.links.incoming': 'Ссылаются',

  // Journal field labels (for revealedFields checkboxes)
  'journal.field.description': 'Описание',
  'journal.field.race': 'Раса',
  'journal.field.occupation': 'Род занятий',
  'journal.field.personality': 'Характер',
  'journal.field.secrets': 'Секреты',
  'journal.field.questHooks': 'Зацепки квестов',
  'journal.field.alive': 'Жив',
  'journal.field.attitude': 'Отношение',
  'journal.field.content': 'Содержание',
  'journal.field.gmNotes': 'Заметки GM',
  'journal.field.objectives': 'Цели',
  'journal.field.rewards': 'Награды',
  'journal.field.status': 'Статус',
  'journal.field.category': 'Категория',
  'journal.field.image': 'Изображение',
  'journal.field.disposition': 'Отношение',

  // Journal: Map integration
  'journal.map.bindNote': 'Привязка к пину карты',
  'journal.map.noteNotFound': 'Пин не найден',
  'journal.map.goToMap': 'На карту',
  'journal.map.pageNotFound': 'Страница не найдена',

  // Journal: NPC CharacterSheet
  'journal.npc.bindSheet': 'Привязать лист',
  'journal.npc.linkedSheet': 'Привязанный лист',
  'journal.npc.sheetDeleted': 'Лист удалён',
  'journal.npc.openSheet': 'Открыть',
  'journal.npc.unbindSheet': 'Отвязать',

  // Journal: Relation labels
  'journal.relation.lives_in': 'Живёт в',
  'journal.relation.quest_giver': 'Квестодатель',
  'journal.relation.member_of': 'Член',
  'journal.relation.enemy_of': 'Враг',

  // === Sheet View ===
  'sheet.speed': 'Скорость',
  'sheet.initiativeMod': 'Инициатива',
  'sheet.tokenDescription': 'Описание токена',
  'sheet.tokenDescriptionPlaceholder': 'Опишите, как ваш персонаж выглядит для других',
  'sheet.tokenDescriptionHint': 'Поддерживается Markdown. Видно всем участникам.',
  'sheet.fullForm': 'Полная форма',
  'sheet.statBlock': 'Стат-блок',
  'sheet.tokenActions': 'Действия токена',
  'sheet.actionName': 'Название',
  'sheet.actionExpression': 'Выражение (1d20+5)',
  'sheet.addAction': '+ Добавить',
  'sheet.hitDice': 'Кость здоровья',
  'sheet.spendHitDie': 'Потратить Hit Die',
  'sheet.featuresTraits': 'Особенности и черты',
  'sheet.uses': 'использований',
  'sheet.rest': 'отдых',
  'sheet.shortRest': 'Короткий отдых',
  'sheet.longRest': 'Длинный отдых',
  'sheet.levelUp': 'Повысить уровень',
  'sheet.encumbered': 'Перегруз!',
  'sheet.rollTooltip': 'Бросить',
  'sheet.proficiency': 'мастерство',

  // === Character Wizard ===
  'wizard.createTitle': 'Создание персонажа',
  'wizard.step': 'Шаг',
  'wizard.createCharacter': 'Создать персонажа',
  'wizard.stepRace': 'Раса',
  'wizard.stepClass': 'Класс',
  'wizard.stepAbilities': 'Характеристики',
  'wizard.stepSkills': 'Навыки',
  'wizard.stepEquipment': 'Снаряжение',
  'wizard.stepSpells': 'Заклинания',
  'wizard.stepReview': 'Обзор',

  // === Conditions (D&D) ===
  'condition.blinded': 'Ослеплён',
  'condition.charmed': 'Очарован',
  'condition.deafened': 'Оглушён',
  'condition.frightened': 'Испуган',
  'condition.grappled': 'Схвачен',
  'condition.incapacitated': 'Недееспособен',
  'condition.invisible': 'Невидим',
  'condition.paralyzed': 'Парализован',
  'condition.petrified': 'Окаменён',
  'condition.poisoned': 'Отравлен',
  'condition.prone': 'Распластан',
  'condition.restrained': 'Сдержан',
  'condition.stunned': 'Ошеломлён',
  'condition.unconscious': 'Без сознания',
  'condition.exhaustion': 'Истощён',
  'condition.concentration': 'Концентрация',

  // === Toast messages ===
  'toast.mapUploaded': 'Карта загружена:',
  'toast.mapUploadError': 'Ошибка загрузки карты',
  'toast.tokenAdded': 'Токен добавлен:',
  'toast.tokenCreated': 'Токен создан:',
  'toast.sessionSaved': 'Сессия сохранена',
  'toast.sessionLoaded': 'Сессия загружена',

  // === Server Error Codes ===
  'error.INVALID_TOKEN': 'Невалидный токен',
  'error.USER_NOT_FOUND': 'Пользователь не найден',
  'error.sessionError': 'Ошибка сессии',
  'error.SESSION_NOT_FOUND': 'Сессия не найдена',
  'error.NOT_AUTHORIZED': 'Нет доступа',
  'error.UNAUTHORIZED': 'Нет доступа',
  'error.NO_SKETCH': 'Скетч не загружен',
  'error.INVALID_PROMPT': 'Промпт обязателен (1-1000 символов)',
  'error.PAGE_NOT_FOUND': 'Страница не найдена',
  'error.AI_UNAVAILABLE': 'AI-провайдер недоступен',
  'error.TIMEOUT': 'Генерация заняла слишком долго. Попробуйте снова',
  'error.AI_ERROR': 'Ошибка генерации. Попробуйте снова',
  'error.AUTH_REQUIRED': 'Требуется вход в аккаунт',
  'error.BAD_REQUEST': 'Неверный запрос',
  'error.NOT_FOUND': 'Не найдено',
  'error.FORBIDDEN': 'Нет прав на это действие',

  // === Pluralization ===
  'plural.participant_one': 'участник',
  'plural.participant_few': 'участника',
  'plural.participant_many': 'участников',
  'plural.day_one': 'день',
  'plural.day_few': 'дня',
  'plural.day_many': 'дней',

  // === AppShell session bar ===
  'session.label': 'Сессия:',
  'session.participantsLabel': 'Участники:',
  'session.disconnect': 'Выйти',
  'session.expandSidebar': 'Развернуть боковую панель',
  'session.collapseSidebar': 'Свернуть боковую панель',
  'session.detachPanel': 'Открепить панель',
  'session.panelDetached': 'Панель открыта в отдельном окне',
  'session.roleGM': 'GM',
  'session.rolePlayer': 'Игрок',
  'session.connectionLost': 'Соединение потеряно. Переподключение...',
  'session.connectionRestored': 'Соединение восстановлено',
  'session.sessionCreated': 'Сессия создана',
  'session.sessionJoined': 'Вы присоединились к сессии',
  'session.participantJoined': 'присоединился к сессии',
  'session.participantLeft': 'покинул сессию',
  'session.pageCreated': 'создана',
  'session.sheetCreated': 'создан',

  // === Input Dialog ===
  'inputDialog.cancel': 'Отмена',
  'inputDialog.confirm': 'Подтвердить',

  // === Confirm Dialog ===
  'confirmDialog.replaceBinding': 'Заменить привязку',
  'confirmDialog.replaceBindingDesc': 'уже привязан к листу. Заменить привязку на',
  'confirmDialog.replace': 'Заменить',

  // === AppDialogs ===
  'appDialogs.loading': 'Загрузка...',

  // === File upload ===
  'upload.mapLoaded': 'Карта загружена:',
  'upload.mapError': 'Ошибка загрузки карты',
  'upload.tokenAdded': 'Токен добавлен:',

  // === Misc ===
  'misc.drawingsCleared': 'Рисунки очищены',
  'misc.sessionSaved': 'Сессия сохранена',
  'misc.sessionLoaded': 'Сессия загружена',
  'misc.loadError': 'Ошибка загрузки файла',
  'misc.hpDialogTitle': 'HP для',
  'misc.resizeDialogTitle': 'Размер (клетки): 0.5, 1, 2, 3, 4:',
  'misc.newTokenDialogTitle': 'Имя нового токена:',

  // === AI Confirm Card ===
  'aiConfirm.details': 'Подробнее',
  'aiConfirm.cancel': 'Отмена',
  'aiConfirm.create': 'Создать',

  // === Chat Roll ===
  'chatRoll.crit': 'Крит!',
  'chatRoll.fumble': 'Провал!',
  'chatRoll.damage': 'Урон',

  // === Condition Tooltip ===
  'conditionTooltip.noDescription': 'Описание не задано',

  // === Confirm Dialog defaults ===
  'confirmDialog.confirm': 'Подтвердить',
  'confirmDialog.cancel': 'Отмена',

  // === Effects Panel ===
  'effects.title': 'Активные эффекты',
  'effects.empty': 'Нет активных эффектов',
  'effects.enable': 'Включить',
  'effects.disable': 'Отключить',
  'effects.remove': 'Удалить',
  'effects.addEffect': '+ Добавить эффект',
  'effects.source': 'Источник',
  'effects.target': 'Цель',
  'effects.mode': 'Режим',
  'effects.value': 'Значение',
  'effects.add': 'Добавить',

  // === AI Map generation count ===
  'aiMap.generationCount': 'генерация',

  // === Note Editor placeholders ===
  'notes.titlePlaceholder': 'Название заметки...',
  'notes.contentPlaceholder': 'Текст заметки (markdown)...',
  'notes.noContent': 'Нет содержимого',
  'notes.quickCreate': 'Быстрое создание',
  'notes.setParent': 'Переместить в...',
  'notes.moveToRoot': 'Переместить в корень',

  // === Map Pins ===
  'pins.title': 'Маркеры на карте',
  'pins.empty': 'Нет маркеров. Нажмите на карту, чтобы создать.',
  'pins.newPin': 'Новый маркер',
  'pins.editPin': 'Редактировать маркер',
  'pins.icon': 'Иконка',
  'pins.color': 'Цвет',
  'pins.selectColor': 'Выбрать цвет',
  'pins.gmOnly': 'Только для мастера',
  'pins.ownerOnly': 'Только для автора',
  'pins.visibility': 'Видимость',
  'pins.linkedEntry': 'Связанная запись журнала',
  'pins.orphan': 'Нет связанной записи',
  'pins.unlinkEntry': 'Отвязать запись',
  'pins.linkEntry': 'Привязать запись...',
  'pins.delete': 'Удалить маркер',
  'pins.deleteConfirm': 'Удалить этот маркер?',
  'pins.created': 'Маркер создан',
  'pins.deleted': 'Маркер удалён',
  'pins.limitReached': 'Достигнут лимит маркеров (максимум 100 на странице)',
  'pins.quickCreate': 'Быстрое создание',
  'pins.noEntry': 'Нет записи',
  'pins.journalEntry': 'Запись журнала',
  'pins.selectEntry': 'Выбрать запись...',
  'pins.visibilityAll': 'Видно всем',

  // === Fullscreen Mini Panel ===
  'fullscreen.round': 'Раунд:',
  'fullscreen.nextTurn': 'Следующий ход',
  'fullscreen.exitFullscreen': 'Выйти из полноэкранного режима',

  // === Location Breadcrumb ===
  'breadcrumb.back': '← Назад',

  // === Navigate Request Toast ===
  'navigate.wantsToGoTo': 'хочет перейти в',
  'navigate.deny': 'Отклонить',
  'navigate.approve': 'Одобрить',

  // === NPC Stat Block ===
  'npc.conditions': 'Состояния:',
  'npc.attacks': 'Атаки',
  'npc.rollAbility': 'Бросить',
  'npc.checkAbility': 'Проверка',
  'npc.rollAttack': 'Бросить атаку',
  'npc.abilityStr': 'СИЛ',
  'npc.abilityDex': 'ЛОВ',
  'npc.abilityCon': 'ТЕЛ',
  'npc.abilityInt': 'ИНТ',
  'npc.abilityWis': 'МДР',
  'npc.abilityCha': 'ХАР',

  // === PopoutWindow ===
  'popout.close': 'Закрыть',

  // === Portrait Upload ===
  'portrait.fileTooLarge': 'Файл слишком большой (макс. 10 МБ)',
  'portrait.networkError': 'Ошибка сети',
  'portrait.alt': 'Портрет',

  // === Repeating Section ===
  'repeating.add': '+ Добавить',
  'repeating.empty': 'Нет записей',
  'repeating.remove': 'Удалить',
  'repeating.showAll': 'Показать все',
  'repeating.hidden': 'скрыто',

  // === Selection Bar ===
  'selectionBar.inspect': 'Описание',
  'selectionBar.edit': 'Редактировать',
  'selectionBar.conditions': 'Состояния',
  'selectionBar.delete': 'Удалить',

  // === Sheet Modal ===
  'sheetModal.popout': 'Открыть в отдельном окне',
  'sheetModal.templateNotFound': 'Шаблон не найден',

  // === Spell Slots Widget ===
  'spells.slotsTitle': 'Ячейки заклинаний',
  'spells.noSlots': 'Нет ячеек заклинаний',
  'spells.level': 'Уровень',
  'spells.spendSlot': 'Потратить ячейку',
  'spells.spent': 'Потрачена',

  // === Token Inspect Popup ===
  'tokenInspect.gmNotes': 'Заметки GM (скрыты от игроков)',
  'tokenInspect.openSheet': 'Открыть лист персонажа',
  'tokenInspect.ac': 'КД:',

  // === Sidebar detached tab ===
  'sidebar.detached': 'открепл.',
  'sidebar.notification': 'Новое уведомление',

  // === SrdPanel filter placeholders ===
  'srd.filterType': 'Тип',
  'srd.filterLevel': 'Уровень',
  'srd.filterSchool': 'Школа',
  'srd.filterClass': 'Класс',
  'srd.filterCategory': 'Категория',
  'srd.filterRarity': 'Редкость',

  // === Dialog close ===
  'dialog.close': 'Закрыть',

  // === Token Panel preset ===
  'tokens.presetToken': 'Токен',

  // === Session Page Tabs ===
  'sessionPage.sessionsTab': 'Сессии',
  'sessionPage.profileTab': 'Профиль',

  // === App (lobby) ===
  'app.profile': 'Профиль',
  'app.logout': 'Выйти',
  'app.joinByCode': 'Присоединиться по коду',

  // === AI Error Messages ===
  'aiError.serviceUnavailable': 'AI-сервис временно недоступен',
  'aiError.rateLimit': 'Слишком много запросов. Подождите минуту.',
  'aiError.networkError': 'Ошибка сети. Проверьте подключение.',
  'aiError.timeout': 'Таймаут: нет ответа от AI',
  'aiError.sendError': 'Ошибка отправки сообщения',
  'aiError.gmOnly': 'Только мастер может использовать AI',
  'aiError.undoExpired': 'Снимок для отмены истёк. Операция не может быть отменена.',
  'aiError.voicePermissionDenied': 'Доступ к микрофону запрещён. Разрешите в настройках браузера.',
  'aiError.voiceNotAvailable': 'Голосовой ввод недоступен.',
  'aiError.tokenBudget': 'Лимит токенов исчерпан. Попробуйте позже.',
  'aiError.playerAiDisabled': 'AI-помощник игрока отключён мастером.',

  // === Player AI ===
  'playerAi.title': 'Тиа',
  'playerAi.inputPlaceholder': 'Спросите Тиа...',
  'playerAi.send': 'Отправить',
  'playerAi.newChat': 'Новый чат',

  // === Game System ===
  'gameSystem.label': 'Игровая система',
  'gameSystem.dnd5e': 'D&D 5e',
  'gameSystem.pf2e': 'Pathfinder 2e',
  'gameSystem.generic': 'Универсальная',
  'srd.unavailable': 'SRD данные доступны только для D&D 5e',

  // === Auth Errors ===
  'authError.loginError': 'Ошибка входа',
  'authError.registerError': 'Ошибка регистрации',
  'authError.updateError': 'Ошибка обновления профиля',
  'authError.networkError': 'Ошибка сети',

  // === Chat ===
  'chat.defaultName': 'Мастер',

  // === Chat Sound Settings ===
  'chat.sound.settings': 'Настройки звука чата',
  'chat.sound.volume': 'Громкость',
  'chat.sound.mute': 'Выключить звук',
  'chat.sound.chatEnabled': 'Звук сообщений',
  'chat.sound.diceEnabled': 'Звук бросков',

  // === Ruler / Measurement ===
  'ruler.ft': 'фт',
  'ruler.total': 'Итого:',

  // === Token copy ===
  'tokens.copySuffix': '(копия)',

  // === Sidebar: Alerts ===
  'sidebar.alerts': 'Алерты',

  // === Sidebar: Timeline ===
  'sidebar.timeline': 'Хронология',

  // === Alerts ===
  'alerts.title': 'Алерты',
  'alerts.create': 'Создать алерт',
  'alerts.edit': 'Редактировать алерт',
  'alerts.delete': 'Удалить',
  'alerts.trigger': 'Запустить',
  'alerts.emptyTitle': 'Нет алертов',
  'alerts.emptyHint': 'Создайте первый алерт для усиления атмосферы',
  'alerts.presets': 'Пресеты',
  'alerts.triggerActive': 'Авто-триггер активен',
  'alerts.nameLabel': 'Название',
  'alerts.visualLabel': 'Визуал (GIF/WebM/PNG/JPEG/WebP)',
  'alerts.soundLabel': 'Звук (MP3/OGG)',
  'alerts.layoutLabel': 'Расположение',
  'alerts.durationLabel': 'Длительность',
  'alerts.volume': 'Громкость',
  'alerts.triggerLabel': 'Триггер',
  'alerts.customEventPlaceholder': 'Название события',
  'alerts.triggerEnabledLabel': 'Включить авто-триггер',
  'alerts.deleteConfirmTitle': 'Удалить алерт?',
  'alerts.deleteConfirmDesc': 'Алерт и связанные медиа-файлы будут удалены навсегда.',
  'alerts.preset.critical-hit': 'Критический удар',
  'alerts.preset.character-death': 'Смерть персонажа',
  'alerts.preset.combat-start': 'Начало боя',
  'alerts.preset.new-location': 'Новая локация',
  'alerts.layout.fullscreen': 'Полный экран',
  'alerts.layout.banner-top': 'Баннер сверху',
  'alerts.layout.banner-bottom': 'Баннер снизу',
  'alerts.duration.auto': 'Авто',
  'alerts.duration.manual': 'Вручную',
  'alerts.trigger.manual': 'Вручную',
  'alerts.trigger.initiative:start': 'Начало инициативы',
  'alerts.trigger.initiative:round': 'Новый раунд',
  'alerts.trigger.token:death': 'Смерть токена',
  'alerts.trigger.roll:critical': 'Критический удар',
  'alerts.trigger.roll:fumble': 'Критический промах',
  'alerts.trigger.page:activate': 'Смена страницы',
  'alerts.trigger.custom': 'Произвольный',
  'alerts.mediaSection': 'Медиа',
  'alerts.settingsSection': 'Настройки',
  'alerts.triggerSection': 'Триггер',
  'alerts.limitCounter': 'Алертов: {count}/{max}',
  'alerts.limitWarning': 'Приближается лимит алертов',
  'alerts.limitReached': 'Достигнут лимит алертов (50)',
  'alerts.triggerLimitReached': 'Достигнут лимит авто-триггеров (20)',
  'alerts.sound.settings': 'Настройки звука алертов',
  'alerts.sound.volume': 'Громкость',
  'alerts.sound.mute': 'Выключить звук',
  'alerts.error.nameRequired': 'Введите название (1-100 символов)',
  'alerts.error.durationRange': 'Длительность от 1 до 30 секунд',
  'alerts.error.customEventRequired': 'Укажите название события',
  'alerts.error.fileTooLarge': 'Максимальный размер файла — 10 МБ',
  'alerts.error.uploadFailed': 'Ошибка загрузки файла',

  // === Stickers ===
  'sticker.title': 'Стикеры',
  'sticker.cooldown': 'Подождите:',
  'sticker.cooldownUnit': 'с',
  'sticker.createPack': 'Создать пак',
  'sticker.connectPack': 'Подключить',
  'sticker.editPack': 'Редактировать',
  'sticker.deletePack': 'Удалить пак',
  'sticker.disconnectPack': 'Отключить',
  'sticker.emptyTitle': 'Нет подключённых стикер-паков',
  'sticker.emptyHint': 'Создайте пак или подключите существующий',
  'sticker.noStickers': 'Пока нет стикеров',
  'sticker.packName': 'Имя пака',
  'sticker.packNamePlaceholder': 'Мемы группы',
  'sticker.stickerCount': 'стикеров',
  'sticker.uploadHint': 'PNG, WebP · до 2 МБ',
  'sticker.uploadDragHint': 'Перетащите файлы сюда',
  'sticker.uploadBrowse': 'Выбрать файлы',
  'sticker.limitReached': 'Достигнут лимит стикеров',
  'sticker.connectTitle': 'Подключить стикер-пак',
  'sticker.connectButton': 'Подключить',
  'sticker.allConnected': 'Все ваши стикер-паки уже подключены к этой сессии',
  'sticker.noPacks': 'У вас нет стикер-паков',
  'sticker.createFirst': 'Создайте первый!',
  'sticker.deleteConfirmTitle': 'Удалить стикер-пак?',
  'sticker.deleteConfirmMessage': 'Пак и все стикеры будут удалены безвозвратно',
  'sticker.disconnectConfirmTitle': 'Отключить стикер-пак?',
  'sticker.disconnectConfirmMessage': 'Стикеры из этого пака станут недоступны в сессии',
  'sticker.builtIn': 'Встроенные',
  'sticker.custom': 'Кастомные',
  'sticker.done': 'Готово',
  'sticker.cancel': 'Отмена',
  'sticker.close': 'Закрыть',
  'sticker.unavailable': 'Стикер недоступен',
  'sticker.emptyPack': 'Пустой пак',
  'sticker.error.formatInvalid': 'Поддерживаются только PNG и WebP',
  'sticker.error.fileTooLarge': 'Файл слишком большой (макс. 2 МБ)',
  'sticker.error.tooManyUploads': 'Слишком много загрузок, подождите',
  'sticker.error.packNotFound': 'Стикер-пак не найден',
  'sticker.error.uploadFailed': 'Ошибка загрузки стикера',
  'sticker.error.limitExceeded': 'Достигнут лимит стикеров в паке',
  'sticker.mediaTab.alerts': 'Алерты',
  'sticker.mediaTab.stickers': 'Стикеры',

  // === Release Notes ===
  'releaseNotes.badgeNew': 'Новая функция',
  'releaseNotes.title': 'Что нового',
  'releaseNotes.menuItem': 'Что нового',
  'releaseNotes.sectionNew': 'Новое',
  'releaseNotes.sectionFix': 'Исправления',
  'releaseNotes.sectionImprovement': 'Улучшения',
  'releaseNotes.currentVersion': 'Текущая версия',
  'releaseNotes.learnMore': 'Подробнее',
  'releaseNotes.version': 'Версия',
  'releaseNotes.empty': 'Нет записей о релизах',

  // === Mobile ===
  'mobile.overflowMenu': 'Ещё',
  'mobile.aiChat': 'AI',
  'mobile.chat': 'Чат',
  'mobile.sheet': 'Лист',
  'mobile.initiative': 'Иниц.',
  'mobile.dice': 'Кубики',
  'mobile.voiceInput': 'Голосовой ввод',
  'mobile.voiceListening': 'Слушаю...',
  'mobile.voiceError': 'Ошибка распознавания',
  'mobile.voiceNotSupported': 'Голосовой ввод не поддерживается',

  'mobile.tokenPlaced': 'Токен размещён',

  // === Mobile Canvas (024-2) ===
  'mobile.tokenPopup.hp': 'ХП',
  'mobile.tokenPopup.close': 'Закрыть',
  'mobile.tokenPopup.conditions': 'Состояния',

  // === Mobile Touch Interactions (024-3) ===
  'mobile.characterSheet.aiHint': 'Попробуйте: скажите AI что изменить',
  'mobile.characterSheet.aiHintDismiss': 'Понятно',

  // === PWA (024-4) ===
  'pwa.offlineBanner': 'Нет подключения к серверу',
  'pwa.installPrompt': 'Установите roll1 на домашний экран',
  'pwa.installButton': 'Установить',
  'pwa.installDismiss': 'Не сейчас',

  // === Push Notifications (024-5) ===
  'push.promptTitle': 'Получать уведомления о ходах?',
  'push.promptAllow': 'Разрешить',
  'push.promptDismiss': 'Не сейчас',

  // === Bug Report ===
  'bugReport.title': 'Сообщить о баге',
  'bugReport.description': 'Опишите проблему — контекст элемента и сессии добавится автоматически.',
  'bugReport.titleLabel': 'Заголовок',
  'bugReport.titlePlaceholder': 'Кратко опишите проблему...',
  'bugReport.descriptionLabel': 'Подробности',
  'bugReport.descriptionPlaceholder': 'Шаги для воспроизведения, ожидаемое/фактическое поведение...',
  'bugReport.cancel': 'Отмена',
  'bugReport.submit': 'Создать Issue',
  'bugReport.submitted': 'Открыта страница создания issue на GitHub',
  'bugReport.menuItem': 'Сообщить о баге',
  'bugReport.rateLimited': 'Слишком много отчётов. Подождите.',
  'bugReport.retryIn': 'Повтор через {{seconds}}с',

  // === Undo/Redo (032-A) ===
  'undo.tokenMove': 'Переместить токен',

  // === AoE Templates (037) ===
  'aoe.cone': 'Конус',
  'aoe.sphere': 'Сфера',
  'aoe.cube': 'Куб',
  'aoe.line': 'Линия',
  'aoe.cylinder': 'Цилиндр',
  'aoe.size': 'Размер (фт)',
  'aoe.color': 'Цвет',
  'aoe.label': 'Заклинание',
  'aoe.clearAll': 'Убрать все',
  'aoe.autoRemove': 'Авто-удаление',
  'aoe.durationNone': 'Нет',
  'aoe.duration1Round': '1 раунд (6с)',
  'aoe.duration1Min': '1 мин',
  'aoe.duration10Min': '10 мин',

  // === Roll Card (037) ===
  'rollCard.hit': 'Попадание!',
  'rollCard.miss': 'Промах',
  'rollCard.damage': 'Урон',
  'rollCard.crit': 'Крит!',
  'rollCard.fumble': 'Провал!',
  'rollCard.breakdown': 'Детали',
  'rollCard.audit': 'Полный лог',

  // === Action HUD (037) ===
  'actionHud.attack': 'Атаки',
  'actionHud.spell': 'Заклинания',
  'actionHud.ability': 'Способности',
  'actionHud.other': 'Прочее',
  'actionHud.compact': 'Компактный',
  'actionHud.expanded': 'Подробный',
  'actionHud.icon': 'Иконка',
  'actionHud.color': 'Цвет',

  // === Death Save (037) ===
  'deathSave.dying': 'Умирает',
  'deathSave.stable': 'Стабилизирован',
  'deathSave.dead': 'Мёртв',
  'deathSave.alive': 'Жив',
  'deathSave.roll': 'Бросить спасбросок',
  'deathSave.success': 'Успех',
  'deathSave.failure': 'Провал',
  'deathSave.nat20': 'Чудо! Персонаж приходит в сознание.',
  'deathSave.nat1': 'Критический провал! Два провала.',
  'deathSave.stabilized': 'Персонаж стабилизирован.',
  'deathSave.died': 'Персонаж мёртв.',

  // === Concentration (037) ===
  'concentration.broken': 'Концентрация сорвана!',
  'concentration.maintained': 'Концентрация удержана',
  'concentration.dc': 'DC {dc}',

  // === Condition: Dead (037) ===
  'condition.dead': 'Мёртв',

  // === Mobile Content Access (034-phase-4) ===
  'mobile.switchLanguage': 'Язык',
  'mobile.notes': 'Заметки',
  'mobile.journal': 'Журнал',
  'mobile.srd': 'SRD',
  'sheetModal.clickToEditName': 'Нажмите для редактирования',

  // === Map Objects ===
  'mapObject.empty': 'Нет объектов на этой странице.',
  'mapObject.createObject': 'Создать объект',
  'mapObject.title': 'Объекты карты',
  'mapObject.visibleAll': 'Видно всем',
  'mapObject.gmOnly': 'Только GM',
  'mapObject.noun': 'Объект карты',
  'mapObject.label': 'Название',
  'mapObject.description': 'Описание',
  'mapObject.category': 'Категория',
  'mapObject.properties': 'Свойства',
  'mapObject.cover': 'Укрытие',
  'mapObject.coverNone': 'Нет',
  'mapObject.coverHalf': 'Половинное',
  'mapObject.coverThreeQuarter': '3/4',
  'mapObject.coverFull': 'Полное',
  'mapObject.state': 'Состояние',
  'mapObject.stateNone': 'Нет',
  'mapObject.stateClosed': 'Закрыто',
  'mapObject.stateOpen': 'Открыто',
  'mapObject.stateBroken': 'Сломано',
  'mapObject.stateLit': 'Зажжено',
  'mapObject.stateExtinguished': 'Погашено',
  'mapObject.traversable': 'Проходимость',
  'mapObject.difficultTerrain': 'Труднопроходимая местность',
  'mapObject.hp': 'HP',
  'mapObject.maxHp': 'Макс. HP',
  'mapObject.locked': 'Заперто',
  'mapObject.damage': 'Урон',
  'mapObject.light': 'Свет',
  'mapObject.lightRadius': 'Радиус (фт)',
  'mapObject.lightColor': 'Цвет',
  'mapObject.display': 'Отображение',
  'mapObject.displayColor': 'Цвет',
  'mapObject.icon': 'Иконка',
  'mapObject.opacity': 'Прозрачность',
  'mapObject.visibility': 'Видимость',
  'mapObject.visibilityGm': 'GM',
  'mapObject.visibilityAll': 'Все',
  'mapObject.interactable': 'Взаимодействие',
  'mapObject.targetPage': 'Целевая страница',
  'mapObject.catFurniture': 'Мебель',
  'mapObject.catTerrain': 'Рельеф',
  'mapObject.catHazard': 'Опасность',
  'mapObject.catDoor': 'Дверь',
  'mapObject.catContainer': 'Контейнер',
  'mapObject.catLight': 'Освещение',
  'mapObject.catCustom': 'Другое',
  'mapObject.coverHalfBadge': 'Половинное укрытие',
  'mapObject.coverThreeQuarterBadge': 'Укрытие 3/4',
  'mapObject.coverFullBadge': 'Полное укрытие',

  // === Fog Confirm Dialogs ===
  'fog.confirmCoverAll.title': 'Покрыть всё туманом?',
  'fog.confirmCoverAll.description': 'Вся карта будет покрыта туманом войны. Это действие нельзя отменить.',
  'fog.confirmClearAll.title': 'Убрать весь туман?',
  'fog.confirmClearAll.description': 'Весь туман войны будет убран с карты. Это действие нельзя отменить.',
  'fog.confirm.confirm': 'Подтвердить',
  'fog.confirm.cancel': 'Отмена',

  // === Quick Access Panel ===
  'quickAccess.title': 'Быстрый доступ',
  'quickAccess.empty': 'Закрепите инструменты, броски или макросы',
  'quickAccess.add': 'Добавить',
  'quickAccess.remove': 'Удалить',
  'quickAccess.collapse': 'Свернуть',
  'quickAccess.expand': 'Развернуть',
  'quickAccess.close': 'Закрыть',
  'quickAccess.categoryTool': 'Инструмент',
  'quickAccess.categoryRoll': 'Бросок',
  'quickAccess.categoryMacro': 'Макрос',
  'quickAccess.rollLabel': 'Метка',
  'quickAccess.rollFormula': 'Формула',
  'quickAccess.macroLabel': 'Метка',
  'quickAccess.macroCommands': 'Команды (по одной на строку)',
  'quickAccess.invalidFormula': 'Некорректная формула кубиков',
  'quickAccess.limitReached': 'Максимум 20 элементов',
  'quickAccess.duplicateTool': 'Инструмент уже добавлен',
  'quickAccess.macroCommandCount': '{count} команд(ы)',
  'quickAccess.categoryAction': 'Действие',
  'quickAccess.categoryTab': 'Вкладка',
  'quickAccess.sectionPinned': 'Закреплённые',
  'quickAccess.sectionRecent': 'Недавние',
  'quickAccess.noSheetsWithActions': 'Нет листов с действиями',
  'quickAccess.duplicateAction': 'Действие уже добавлено',
  'quickAccess.duplicateTab': 'Вкладка уже добавлена',
  'shortcuts.toggleQuickAccess': 'Панель быстрого доступа',

  // === Settings Dialog ===
  'settings.title': 'Настройки',
  'settings.tab.ai': 'AI-ассистент',
  'settings.tab.campaign': 'Кампания',
  'settings.tab.display': 'Отображение',
  'settings.tab.combat': 'Правила боя',
  'settings.tab.permissions': 'Права',
  'settings.tab.resources': 'Ресурсы',
  'settings.resources.gmOnly': 'Ресурсы кампании видит только мастер.',
  'settings.resources.loadError': 'Не удалось загрузить статистику',
  'settings.resources.tokens30d': 'AI-токены · 30 дней',
  'settings.resources.money30d': 'Расход AI за период',
  'settings.resources.moneyText': 'текст',
  'settings.resources.moneyImage': 'картинки',
  'settings.resources.moneyVoice': 'голос',
  'settings.resources.moneyBilled': 'к оплате',
  'settings.resources.players': 'игроки',
  'settings.resources.tokensAllTime': 'AI-токены · всего',
  'settings.resources.allTimeHint': 'за всю историю кампании',
  'settings.resources.interactions30d': 'AI-запросов · 30 дней',
  'settings.resources.chartTitle': 'Расход токенов по дням (30 дней)',
  'settings.resources.tokensUnit': 'токенов',
  'settings.resources.interactionsUnit': 'запросов',
  'settings.resources.tableToggle': 'Показать таблицей',
  'settings.resources.colDay': 'День',
  'settings.resources.colTokens': 'Токены',
  'settings.resources.colInteractions': 'Запросы',

  // AI tab
  'settings.ai.worldDescription': 'Описание мира',
  'settings.ai.worldDescriptionPlaceholder': 'Опишите мир, сеттинг, ключевые локации...',
  'settings.ai.houseRules': 'Домашние правила',
  'settings.ai.houseRulesPlaceholder': 'Кастомные правила или модификации...',
  'settings.ai.tone': 'Тон',
  'settings.ai.gmInstructions': 'Инструкции для GM',
  'settings.ai.gmInstructionsPlaceholder': 'Инструкции для AI-ассистента...',
  'settings.ai.excludedEntities': 'Исключённые сущности (спойлер-гард)',
  'settings.ai.searchEntities': 'Поиск персонажей, заметок...',
  'settings.ai.sectionPriority': 'Приоритет секций AI-контекста',
  'settings.ai.briefingFocus': 'Фокус сессии',
  'settings.ai.briefingFocusDesc': 'О чём эта сессия — AI ставит это выше общего контекста',
  'settings.ai.briefingFocusPlaceholder': 'напр. Партия проникает на бал-маскарад герцога...',
  'settings.ai.briefingActiveNpcs': 'Активные NPC',
  'settings.ai.briefingActiveNpcsDesc': 'Имена через запятую, которых AI держит «на сцене» в этой сессии',
  'settings.ai.briefingActiveNpcsPlaceholder': 'Герцог Алдрик, капитан Вэй, незнакомец в маске',
  'settings.ai.snapshotsLabel': 'Снимки AI-операций (undo)',

  // Campaign tab
  'settings.campaign.measurementMode': 'Режим измерений',
  'settings.campaign.gridSizeFt': 'Размер клетки (фт)',
  'settings.campaign.navigationMode': 'Режим навигации',
  'settings.campaign.navFree': 'Свободный',
  'settings.campaign.navConfirm': 'С подтверждением',
  'settings.campaign.navGmOnly': 'Только GM',
  'settings.campaign.importCampaign': 'Импорт кампании',

  // Display tab
  'settings.display.gridStyle': 'Стиль сетки',
  'settings.display.gridLines': 'Линии',
  'settings.display.gridDots': 'Точки',
  'settings.display.gridNone': 'Без сетки',
  'settings.display.gridOpacity': 'Прозрачность сетки',
  'settings.display.sizeTiny': 'Крошечный',
  'settings.display.sizeSmall': 'Маленький',
  'settings.display.sizeMedium': 'Средний',
  'settings.display.sizeLarge': 'Большой (2×2)',
  'settings.display.sizeHuge': 'Огромный (3×3)',
  'settings.display.sizeGargantuan': 'Громадный (4×4)',
  'settings.display.ambientOverlay': 'Освещение времени суток',
  'settings.display.hpBarVisibility': 'Отображение HP-бара',
  'settings.display.hpAlways': 'Всегда',
  'settings.display.hpHover': 'При наведении',
  'settings.display.hpGmOnly': 'Только GM',
  'settings.display.hpNever': 'Никогда',
  'settings.display.defaultTokenSize': 'Размер токена по умолчанию',

  // Combat tab
  'settings.combat.autoRollInitiative': 'Автобросок инициативы',
  'settings.combat.autoRollInitiativeDesc': 'Автоматически бросить d20 + модификатор ЛОВ при запуске инициативы',
  'settings.combat.confirmDamage': 'Подтверждение урона',
  'settings.combat.confirmDamageDesc': 'Показать диалог подтверждения перед применением урона',
  'settings.combat.critRange': 'Диапазон крита',
  'settings.combat.critRangeDesc': 'Минимальное значение d20 для критического удара (по умолчанию: 20)',
  'settings.combat.deathSavesEnabled': 'Спасброски от смерти',
  'settings.combat.deathSavesEnabledDesc': 'Включить спасброски от смерти D&D 5e',

  // Permissions tab
  'settings.permissions.description': 'Настройте, что могут делать игроки. GM всегда имеет полный доступ.',
  'settings.permissions.moveOtherTokens': 'Двигать чужие токены',
  'settings.permissions.moveOtherTokensDesc': 'Разрешить игрокам двигать неназначенные им токены',
  'settings.permissions.drawOnMap': 'Рисовать на карте',
  'settings.permissions.drawOnMapDesc': 'Разрешить игрокам использовать инструменты рисования',
  'settings.permissions.addTokens': 'Добавлять токены',
  'settings.permissions.addTokensDesc': 'Разрешить игрокам создавать токены на карте',
  'settings.permissions.createNotes': 'Создавать заметки',
  'settings.permissions.createNotesDesc': 'Разрешить игрокам создавать пины и заметки на карте',
  'settings.permissions.useAi': 'Использовать AI',
  'settings.permissions.useAiDesc': 'Разрешить игрокам взаимодействовать с AI-ассистентом',
  'settings.permissions.playerAiRate': 'Лимит запросов к AI',
  'settings.permissions.playerAiRateDesc': 'Максимум запросов к AI на игрока в минуту (1–60)',
  'settings.permissions.playerAiBudget': 'Бюджет токенов AI',
  'settings.permissions.playerAiBudgetDesc': 'Максимум токенов AI на игрока в час. Пусто — без лимита',
  'settings.permissions.unlimited': 'Без лимита',
  'settings.permissions.allowPlayerStickers': 'Стикеры игрокам',
  'settings.permissions.allowPlayerStickersDesc': 'Разрешить игрокам отправлять стикеры и управлять наборами',
  'settings.permissions.viewOtherSheets': 'Просмотр чужих листов',
  'settings.permissions.viewOtherSheetsDesc': 'Что игроки могут видеть на листах других персонажей',
  'settings.permissions.viewNone': 'Ничего',
  'settings.permissions.viewBasic': 'Базовое (публичные поля)',
  'settings.permissions.viewFull': 'Полное',

  // V003: Tool options all settings link
  'toolOptions.allSettings': 'Все настройки...',

  // V005: Confirm damage prompt
  'combat.confirmDamagePrompt': 'Применить {damage} урона к {name}?',

  // V006: Permission denied tooltips
  'permissions.denied.drawOnMap': 'Рисование отключено GM',
  'permissions.denied.addTokens': 'Создание токенов отключено GM',
  'permissions.denied.createNotes': 'Создание заметок отключено GM',

  // === Server Error Codes (command:error) ===
  'error.not_found': 'Не найдено',
  'error.unauthorized': 'Нет прав',
  'error.forbidden': 'Доступ запрещён',
  'error.invalid_input': 'Некорректный ввод',
  'error.invalid_name': 'Некорректное имя',
  'error.invalid_data': 'Некорректные данные',
  'error.invalid_type': 'Некорректный тип',
  'error.invalid_tags': 'Слишком много тегов',
  'error.invalid_visibility': 'Некорректная видимость',
  'error.duplicate': 'Уже существует',
  'error.duplicate_link': 'Связь уже существует',
  'error.self_link': 'Нельзя связать с самим собой',
  'error.self_reference': 'Нельзя ссылаться на себя',
  'error.circular_reference': 'Циклическая ссылка',
  'error.LINK_NOT_FOUND': 'Связь не найдена',
  'error.links_limit': 'Достигнут лимит ссылок',
  'error.PAGE_LIMIT': 'Достигнут лимит: максимум 20 страниц',
  'error.CANNOT_DELETE_LAST': 'Нельзя удалить единственную страницу',
  'error.INVALID_PAGE_LIST': 'Некорректный список страниц',
  'error.SAME_PAGE': 'Исходная и целевая страницы совпадают',
  'error.TOKEN_NOT_FOUND': 'Токен не найден',
  'error.SHEET_NOT_FOUND': 'Лист персонажа не найден',
  'error.alert_limit': 'Достигнут лимит алертов (50)',
  'error.trigger_limit': 'Достигнут лимит авто-триггеров (20)',
  'error.unknown_preset': 'Неизвестный пресет',
  'error.invalid_label': 'Некорректное название',
  'error.invalid_color': 'Некорректный цвет',
  'error.invalid_icon': 'Некорректная иконка',
  'error.invalid_content': 'Некорректное содержимое',
  'error.invalid_title': 'Некорректный заголовок',
  'error.note_limit': 'Достигнут лимит заметок',
  'error.parent_not_found': 'Родительская заметка не найдена',
  'error.invalid_area': 'Некорректная область',
  'error.invalid_description': 'Некорректное описание',
  'error.invalid_terrain': 'Некорректный тип местности',
  'error.invalid_cover': 'Некорректный тип укрытия',
  'error.TARGET_PAGE_NOT_FOUND': 'Целевая страница не найдена',
  'error.NAVIGATE_REQUEST_NOT_FOUND': 'Запрос перехода не найден',
  'error.GM_ONLY_NAVIGATION': 'Только GM может переключать страницы в этом режиме',
  'error.builtin_template': 'Нельзя редактировать встроенный шаблон',
  'error.in_use': 'Шаблон используется листами персонажей',
  'error.validation_error': 'Ошибка валидации',
  'error.invalid_state': 'Некорректное состояние',
  'error.death_saves_disabled': 'Спасброски от смерти отключены',
  'error.system_not_supported': 'Недоступно для этой игровой системы',
  'error.exhausted': 'Способность исчерпана',
  'error.no_hit_dice': 'Нет доступных хит-дайсов',
  'error.no_spell_slots': 'Нет доступных ячеек заклинаний',
  'error.no_pact': 'Магия договора не настроена',
  'error.not_repeating': 'Секция не является повторяемой',
  'error.invalid_action': 'Некорректное действие',
  'error.invalid_expression': 'Некорректное выражение',
  'error.invalid_level': 'Некорректный уровень',
  'error.invalid_mode': 'Некорректный режим',
  'error.not_draft': 'Не является черновиком',
  'error.session_limit': 'Достигнут лимит сессий',
  'error.session_full': 'Сессия заполнена',
  'error.active_limit': 'Может быть только одна активная сессия',
  'error.timeline_limit': 'Достигнут лимит событий таймлайна',
  'error.tags_limit': 'Достигнут лимит тегов',
  'error.PIN_LIMIT': 'Достигнут лимит маркеров',
  'error.PIN_NOT_FOUND': 'Маркер не найден',
  'error.WALL_NOT_FOUND': 'Стена не найдена',
  'error.WALL_INVALID': 'Некорректная стена',
  'error.WALL_LIMIT': 'Достигнут лимит стен',
  'error.WALL_NOT_DOOR': 'Стена не является дверью',
  'error.WALL_CHAIN_MIN_POINTS': 'Стена должна иметь минимум 2 точки',
  'error.INVALID_ILLUMINATION': 'Некорректное значение освещения',
  'error.invalid_condition': 'Некорректное состояние',
  'error.invalid_transition': 'Некорректный переход',
  'error.restore_failed': 'Ошибка восстановления',
  'error.max_level': 'Достигнут максимальный уровень',
  'error.trigger_disabled': 'Триггер отключён',
  'error.internal_error': 'Внутренняя ошибка',

  // === Timeline ===
  'timeline.eventType.sessionStart': 'Начало сессии',
  'timeline.eventType.sessionRecap': 'Итоги сессии',
  'timeline.eventType.encounter': 'Столкновение',
  'timeline.eventType.discovery': 'Открытие',
  'timeline.eventType.plot': 'Сюжет',
  'timeline.eventType.travel': 'Путешествие',
  'timeline.eventType.rest': 'Отдых',
  'timeline.eventType.downtime': 'Свободное время',
  'timeline.eventType.character': 'Персонаж',
  'timeline.eventType.custom': 'Другое',
  'timeline.eventType.chapter': 'Глава',
  'timeline.timeOfDay.dawn': 'Рассвет',
  'timeline.timeOfDay.morning': 'Утро',
  'timeline.timeOfDay.midday': 'Полдень',
  'timeline.timeOfDay.afternoon': 'День',
  'timeline.timeOfDay.dusk': 'Закат',
  'timeline.timeOfDay.evening': 'Вечер',
  'timeline.timeOfDay.night': 'Ночь',
  'timeline.timeOfDay.midnight': 'Полночь',
  'timeline.form.editTitle': 'Редактировать событие',
  'timeline.form.newTitle': 'Новое событие',
  'timeline.form.titleLabel': 'Заголовок',
  'timeline.form.titlePlaceholder': 'Что произошло?',
  'timeline.form.typeLabel': 'Тип события',
  'timeline.form.descriptionLabel': 'Описание',
  'timeline.form.descriptionPlaceholder': 'Подробности...',
  'timeline.form.yearLabel': 'Год',
  'timeline.form.monthLabel': 'Месяц',
  'timeline.form.dayLabel': 'День',
  'timeline.form.timeOfDayLabel': 'Время суток',
  'timeline.form.manualTimeOverride': 'Ручной ввод текста времени',
  'timeline.form.customTimePlaceholder': 'Своё описание времени',
  'timeline.form.timeTextLabel': 'Время (текст)',
  'timeline.form.timeLabelPlaceholder': 'День 3, Утро',
  'timeline.form.sortKeyLabel': 'Порядок (sortKey)',
  'timeline.form.visibilityLabel': 'Видимость',
  'timeline.form.visibilityAll': 'Все',
  'timeline.form.visibilityGmOnly': 'Только ГМ',
  'timeline.form.visibilityPlayers': 'Игроки',
  'timeline.form.tagsLabel': 'Теги (через запятую)',
  'timeline.form.tagsPlaceholder': 'бой, дракон, Уотердип',
  'timeline.form.linksLabel': 'Ссылки',
  'timeline.form.sessionLabel': 'Сессия',
  'timeline.form.noSession': 'Без сессии',
  'timeline.form.cancelButton': 'Отмена',
  'timeline.form.saveButton': 'Сохранить',
  'timeline.form.createButton': 'Создать',
  'timeline.form.suggestButton': 'Предложить',
  'timeline.filters.title': 'Фильтры',
  'timeline.filters.resetAriaLabel': 'Сбросить все фильтры',
  'timeline.filters.reset': 'Сбросить',
  'timeline.filters.searchPlaceholder': 'Поиск по заголовку и описанию...',
  'timeline.filters.searchAriaLabel': 'Поиск по событиям',
  'timeline.filters.typeGroupLabel': 'Фильтр по типу',
  'timeline.filters.tagsGroupLabel': 'Фильтр по тегам',
  'timeline.filters.allSessions': 'Все сессии',
  'timeline.filters.myEventsOnly': 'Мои события',
  'timeline.cursor.dayFormat': 'День',
  'timeline.cursor.editDateTooltip': 'Изменить дату',
  'timeline.cursor.addDate': '+ дата',
  'timeline.cursor.nextDayTooltip': 'Следующий день',
  'timeline.cursor.nextDayButton': '+1д',
  'timeline.cursor.markerTooltip': 'Маркер при смене времени',
  'timeline.cursor.monthShort': 'мес',
  'timeline.cursor.saveTooltip': 'Сохранить',
  'timeline.cursor.cancelTooltip': 'Отмена',
  'timeline.list.noDate': 'Без даты',
  'timeline.list.addEventToDay': 'Добавить событие в этот день',
  'timeline.list.draftBadge': 'черновик',
  'timeline.list.editTooltip': 'Изменить',
  'timeline.list.deleteTooltip': 'Удалить',
  'timeline.drafts.regionLabel': 'Черновики на модерацию',
  'timeline.drafts.title': 'Черновики на модерацию',
  'timeline.drafts.approveAriaLabel': 'Одобрить',
  'timeline.drafts.rejectAriaLabel': 'Отклонить',
  'timeline.panel.emptyTitle': 'Таймлайн пуст',
  'timeline.panel.emptySubtext': 'Пока нет событий кампании',
  'timeline.panel.regionLabel': 'Таймлайн кампании',
  'timeline.panel.noTime': 'Время не задано',
  'timeline.panel.createEventAriaLabel': 'Создать событие',
  'timeline.panel.noFilterResults': 'Нет событий по заданным фильтрам',
  'timeline.panel.emptySubtextGM': 'Создайте первое событие кампании',
  'timeline.panel.createEventButton': 'Создать событие',

  // === Campaign Sessions ===
  'campaignSessions.ariaLabel': 'Управление игровыми сессиями',
  'campaignSessions.title': 'Сессии',
  'campaignSessions.newSession': 'Новая сессия',
  'campaignSessions.titleLabel': 'Название (необязательно)',
  'campaignSessions.namePlaceholder': 'Подземелье дракона',
  'campaignSessions.dateLabel': 'Дата',
  'campaignSessions.active': 'Активна',
  'campaignSessions.complete': 'Завершить',
  'campaignSessions.planned': 'Планируется',
  'campaignSessions.start': 'Начать',
  'campaignSessions.completed': 'Завершённые',
  'campaignSessions.noSessions': 'Пока нет сессий',

  // === Import Wizard ===
  'importWizard.title': 'Импорт кампании',
  'importWizard.sourceText': 'Текст / заметки',
  'importWizard.selectSource': 'Выберите источник',
  'importWizard.sourceDndBeyondSoon': 'D&D Beyond (скоро)',
  'importWizard.sourcePdfSoon': 'PDF (скоро)',
  'importWizard.sourceImageSoon': 'Изображение (скоро)',
  'importWizard.extractingRelations': 'Извлечение связей...',
  'importWizard.analyzingRelations': 'Анализ связей между сущностями',
  'importWizard.wave1': 'Контейнеры (страницы, листы)',
  'importWizard.wave2': 'Контент (журнал, заметки)',
  'importWizard.wave3': 'Связи (ссылки, маркеры)',
  'importWizard.importError': 'Ошибка импорта',
  'importWizard.source': 'Источник',
  'importWizard.dragDropHint': 'Перетащите файл сюда или нажмите для выбора',
  'importWizard.analyzing': 'Анализ...',
  'importWizard.analyze': 'Анализировать',
  'importWizard.conflictsFound': 'Обнаружены конфликты',
  'importWizard.tableType': 'Тип',
  'importWizard.tableName': 'Имя',
  'importWizard.tableAction': 'Действие',
  'importWizard.tableNewName': 'Новое имя',
  'importWizard.strategySkip': 'Пропустить',
  'importWizard.strategyMerge': 'Объединить',
  'importWizard.strategyRename': 'Переименовать',
  'importWizard.newNamePlaceholder': 'Новое имя',
  'importWizard.applying': 'Применение...',
  'importWizard.apply': 'Применить',
  'importWizard.importPreview': 'Предпросмотр импорта',
  'importWizard.importComplete': 'Импорт завершён',
  'importWizard.stepSource': 'Источник',
  'importWizard.stepUpload': 'Загрузка',
  'importWizard.stepConflicts': 'Конфликты',
  'importWizard.stepResult': 'Результат',
  'importWizard.strategyOverwrite': 'Перезаписать',
  'importWizard.previewSheets': 'Персонажи',
  'importWizard.previewTokens': 'Токены',
  'importWizard.previewPages': 'Страницы',
  'importWizard.previewNotes': 'Заметки',
  'importWizard.resultAdded': 'Добавлено',
  'importWizard.resultOverwritten': 'Перезаписано',
  'importWizard.resultSkipped': 'Пропущено',

  // === Bug Report additions ===
  'bugReport.sectionDescription': '## Описание',
  'bugReport.sectionElement': '## Элемент',
  'bugReport.sectionContext': '## Контекст',
  'bugReport.noDescription': '_Нет описания_',
  'bugReport.roleGM': 'GM',
  'bugReport.rolePlayer': 'Игрок',

  // === SRD labels ===
  'srd.traits': 'Особенности',
  'srd.actions': 'Действия',
  'srd.reactions': 'Реакции',
  'srd.legendaryActions': 'Легендарные действия',
  'srd.castingTime': 'Время каста',
  'srd.range': 'Дальность',
  'srd.components': 'Компоненты',
  'srd.duration': 'Длительность',
  'srd.resistances': 'Сопротивления',
  'srd.immunities': 'Иммунитеты',
  'srd.senses': 'Чувства',
  'srd.languages': 'Языки',
  'srd.cr': 'КО',

  // === Spellbook ===
  'spellbook.title': 'Книга заклинаний',
  'spellbook.empty': 'Нет заклинаний в книге',
  'spellbook.cantrips': 'Заговоры',
  'spellbook.concentration': 'Концентрация',

  // === Compendium Browser ===
  'compendium.equipment': 'Снаряжение',
  'compendium.spells': 'Заклинания',
  'compendium.searchEquipment': 'Поиск снаряжения...',
  'compendium.searchSpells': 'Поиск заклинаний...',
  'compendium.noEquipment': 'Снаряжение не найдено.',
  'compendium.noSpells': 'Заклинания не найдены.',
  'compendium.addToInventory': 'Добавить в инвентарь',
  'compendium.addToSpellbook': 'Добавить в книгу заклинаний',
  'compendium.cost': 'Стоимость',
  'compendium.weight': 'Вес',
  'compendium.ac': 'КД',
  'compendium.homebrew': 'Хоумбрю',
  'compendium.concentration': 'Концентрация',
  'compendium.properties': 'Свойства',

  // === Chat additions ===
  'chat.search': 'Поиск',
  'chat.searchPlaceholder': 'Поиск...',
  'chat.unpinMessage': 'Открепить сообщение',
  'chat.pinMessage': 'Закрепить сообщение',
  'chat.gmPrefix': '[ГМ] ',
  'chat.exportTitle': '# Экспорт чата',

  // === Character Wizard additions ===
  'wizard.characterNameLabel': 'Имя персонажа',
  'wizard.characterNamePlaceholder': 'Введите имя персонажа...',
  'wizard.backgroundLabel': 'Предыстория',
  'wizard.backgroundPlaceholder': 'Предыстория персонажа...',
  'wizard.raceLabel': 'Раса',
  'wizard.speed': 'Скорость',
  'wizard.classLabel': 'Класс',
  'wizard.hitDie': 'Хит-дайс',
  'wizard.selectClassFirst': 'Сначала выберите класс.',
  'wizard.noEquipmentPack': 'Нет стартового набора для этого класса.',
  'wizard.equipped': '(экипировано)',

  // === Campaign Import ===
  'campaignImport.textInputHint': 'Вставьте текст кампании или загрузите файл (.txt, .md)',
  'campaignImport.placeholder': 'Вставьте текст описания кампании, NPC, локаций, квестов...',
  'campaignImport.uploadFile': 'Загрузить файл',
  'campaignImport.limitExceeded': 'Текст превышает лимит. Сократите или разбейте на части.',
  'campaignImport.analyzing': 'Анализ...',
  'campaignImport.analyze': 'Анализировать',

  // === Homebrew Import ===
  'homebrewImport.title': 'Импорт хоумбрю-контента',
  'homebrewImport.inputLabel': 'Вставьте текст или загрузите PDF',
  'homebrewImport.placeholder': 'Вставьте хоумбрю-контент...',
  'homebrewImport.or': 'или',
  'homebrewImport.uploadPdf': 'Загрузить PDF',
  'homebrewImport.extract': 'Извлечь сущности',
  'homebrewImport.uploading': 'Загрузка PDF...',
  'homebrewImport.backgroundNote': 'Можно закрыть диалог — извлечение продолжится в фоне.',
  'homebrewImport.extracting': 'Извлечение сущностей с помощью AI...',
  'homebrewImport.preparingChunks': 'Подготовка чанков...',
  'homebrewImport.packageNameLabel': 'Название пакета',
  'homebrewImport.save': 'Сохранить',
  'homebrewImport.saving': 'Сохранение пакета...',
  'homebrewImport.complete': 'Импорт завершён!',
  'homebrewImport.back': 'Назад',
  'homebrewImport.clear': 'Очистить',
  'homebrewImport.chunk': 'Чанк',
  'homebrewImport.entities': 'сущностей',

  // === Entity Review ===
  'entityReview.selectAll': 'Выбрать все',
  'entityReview.deselectAll': 'Снять выбор',
  'entityReview.addManual': '+ Добавить вручную',
  'entityReview.selectedCount': 'выбрано',
  'entityReview.retryBelow': 'Повторить ниже',
  'entityReview.retry': 'Повторить',

  // === Character Portraits ===
  'characterPortraits.changeColor': 'Сменить цвет',
  'characterPortraits.online': 'онлайн',
  'characterPortraits.offline': 'офлайн',
  // Visibility menu items
  'characterPortraits.visibility.always': 'Виден всем',
  'characterPortraits.visibility.gmOnly': 'Скрыт от игроков',
  'characterPortraits.visibility.hidden': 'Архив (скрыт от всех)',
  'characterPortraits.visibilityLabel': 'Карточка на сцене',
  'characterPortraits.sheetLabel': 'Лист персонажа',
  'characterPortraits.sheetVisibleToPlayers': 'Виден игрокам',
  'characterPortraits.sheetHiddenBadge': 'Лист скрыт от игроков (hide в списке персонажей)',
  'characterPortraits.sizeLabel': 'Размер аватарок',
  'characterPortraits.size.small': 'Маленькие',
  'characterPortraits.size.medium': 'Средние',
  'characterPortraits.size.large': 'Большие',
  'characterPortraits.actingAs': 'Вы действуете за этого персонажа',
  'characterPortraits.hiddenFromPlayers': 'Скрыт от игроков',
  // Tooltips
  'characterPortraits.tooltip.actorFrame': 'Рамка активного актора',
  'characterPortraits.tooltip.translucency': 'Полупрозрачность',

  // === Text Input Overlay ===
  'textInput.ariaLabel': 'Ввод текста',
  'textInput.placeholder': 'Введите текст...',

  // === Dice Panel ===
  'dice.formulaPlaceholder': '2d6+3, 1d20+5...',

  // === Lobby ===
  'lobby.sessionCodePlaceholder': 'ABC123',

  // === Hook Errors ===
  'hookError.catalogFailed': 'Ошибка каталогизации',
  'hookError.noEntitiesFound': 'Не удалось найти сущности кампании. Попробуйте уточнить текст.',
  'hookError.detailFailed': 'Ошибка детализации',
  'hookError.noResponseBody': 'Нет тела ответа',
  'hookError.relationFailed': 'Ошибка извлечения связей',
  'hookError.applyFailed': 'Ошибка применения',
  'hookError.fileTooLarge': 'Файл слишком большой',
  'hookError.serverError': 'Ошибка сервера',
  'hookError.networkError': 'Ошибка сети',
  'hookError.extractionFailed': 'Ошибка извлечения',
  'hookError.streamEnded': 'Поток завершился без результата',
  'hookError.retryFailed': 'Ошибка повтора',
  'hookError.saveFailed': 'Ошибка сохранения',
  'hookError.loadFailed': 'Ошибка загрузки',
  'hookError.createFailed': 'Ошибка создания',
  'hookError.uploadFailed': 'Ошибка загрузки файла',
  'hookError.generationFailed': 'Ошибка генерации',
  'hookError.canvasContext': 'Canvas 2d контекст недоступен',
  'hookError.mapLoadFailed': 'Не удалось загрузить изображение карты',
  'hookError.pageCreateTimeout': 'Таймаут создания страницы',
  'hookError.lassoMinPoints': 'Лассо требует минимум 3 точки',
  'hookError.exportFailed': 'Ошибка экспорта маски',
  'homebrew.defaultPackageName': 'Импортированный хоумбрю',

  // === Homebrew Library / Import Flow (P2) ===
  'homebrew.libraryTitle': 'Библиотека хоумбрю',
  'homebrew.import': '+ Импорт',
  'homebrew.importJson': 'Импорт JSON',
  'homebrew.libraryEmpty': 'Пакетов пока нет. Импортируй контент, чтобы начать.',
  'homebrew.loading': 'Загрузка...',
  'homebrew.export': 'Экспорт',
  'homebrew.delete': 'Удалить',
  'homebrew.confirm': 'Подтвердить',
  'homebrew.cancel': 'Отмена',
  'homebrew.entities': 'сущностей',
  'homebrew.connectTitle': 'Пакеты хоумбрю',
  'homebrew.connectLoading': 'Загрузка пакетов...',
  'homebrew.connectEmpty': 'В библиотеке нет пакетов. Сначала импортируй контент.',
  'homebrew.checkUpdates': 'Проверить обновления',
  'homebrew.extracting': 'Извлечение...',
  'homebrew.reviewReady': 'Извлечение завершено — нажми, чтобы проверить {{count}} сущностей',
  'homebrew.type.class': 'Класс',
  'homebrew.type.subclass': 'Сабкласс',
  'homebrew.type.spell': 'Заклинание',
  'homebrew.type.feat': 'Черта',
  'homebrew.type.race': 'Раса',
  'homebrew.type.item': 'Предмет',
  'homebrew.connectFailed': 'Не удалось подключить пакет',
  'homebrew.updateFailed': 'Не удалось проверить обновления',

  // === Lazy chunk loading ===
  'error.chunkLoadFailed': 'Не удалось загрузить компонент. Проверьте соединение с интернетом.',

  // === Common additions ===
  'common.retry': 'Попробовать снова',

  // === Character HUD (066) ===
  'characterHud.pillHp': 'ХП',
  'characterHud.expand': 'Развернуть',
  'characterHud.collapse': 'Свернуть',
  'characterHud.openFullSheet': 'Полный лист',
  'characterHud.startCombat': '⚔ начать бой',
  'characterHud.expandDocked': 'Закрепить панель',
  'characterHud.showCharacter': 'Персонаж: статы, навыки, фичи',
  'characterHud.combatBanner': '⚔ твой ход',
  'characterHud.combatBannerIdle': '⚔ бой',
  'characterHud.round': 'раунд',
  'characterHud.tileHp': 'ХП',
  'characterHud.tileAc': 'КЗ',
  'characterHud.tileInit': 'Иниц',
  'characterHud.tileConc': 'Конц',
  'characterHud.tileSpeed': 'Скор',
  'characterHud.actionAction': 'Действие',
  'characterHud.actionBonus': 'Бонус',
  'characterHud.actionReaction': 'Реакция',
  'characterHud.available': 'доступно',
  'characterHud.spent': 'потрачено',
  'characterHud.attacks': 'Атаки',
  'characterHud.spellSlots': 'Ячейки заклинаний',
  'characterHud.effects': 'Эффекты',
  'characterHud.noConcentration': '—',
  'characterHud.mockRoll': 'Бросок (демо)',
  'characterHud.mockRollDesc': 'Демонстрационный бросок, не отправлен на сервер.',
  'characterHud.tabCombat': 'Бой',
  'characterHud.tabCharacter': 'Персонаж',
  'characterHud.tabCharShort': 'Перс',
  'characterHud.tabRoleplay': 'Отыгрыш',
  'characterHud.tabBuilder': 'Создание',
  'characterHud.backToHud': '← в HUD',
  'characterHud.inDevelopment': 'В разработке',
  'characterHud.stats': 'Характеристики',
  'characterHud.topSkills': 'Топ навыков',
  'characterHud.saves': 'Спасброски',
  'characterHud.skills': 'Навыки',
  'characterHud.searchSkills': 'поиск навыка…',
  'characterHud.pinSkill': 'Закрепить навык',
  'characterHud.unpinSkill': 'Открепить навык',
  'characterHud.spells': 'Заклинания',
  'characterHud.detailCantrip': 'заговор',
  'characterHud.detailCircle': 'круг',
  'characterHud.detailConcentration': 'концентрация',
  'characterHud.detailRitual': 'ритуал',
  'characterHud.detailCastingTime': 'время',
  'characterHud.detailRange': 'дистанция',
  'characterHud.detailDuration': 'длительность',
  'characterHud.detailComponents': 'компоненты',
  'characterHud.detailUses': 'использования',
  'characterHud.detailHigherLevels': 'На более высоких кругах',
  'characterHud.conditionAdd': 'состояние',
  'characterHud.conditionRemove': 'Снять состояние',
  'characterHud.conditionRounds': 'раундов (пусто = бессрочно)',
  'characterHud.conditionApply': 'Наложить',
  'characterHud.collapseList': 'свернуть',
  'characterHud.movement': 'Движение',
  'characterHud.movementHint': 'Клик — потратить 5 фт; на нуле — сбросить',
  'characterHud.resetTurn': 'Вернуть ресурсы хода (действия + движение)',
  'characterHud.features': 'Способности',
  'characterHud.moreFeatures': 'ещё',
  'characterHud.spellsKnown': 'Подготовленные заклинания',
  'characterHud.demoTitle': 'HUD Demo',
  'characterHud.demoPill': 'Pill',
  'characterHud.demoMini': 'Mini',
  'characterHud.demoCombat': 'Combat',
  'characterHud.demoDocked': 'Docked',
  'characterHud.demoToggle': 'Видимость',
  'characterHud.demoFullSheet': 'Полный лист',
  'characterHud.demoNpc': 'NPC-карта',
  'characterHud.demoReset': 'Сброс',
  'characterHud.npcAlly': 'союзник',
  'characterHud.npcWarm': 'дружелюбный',
  'characterHud.npcNeutral': 'нейтральный',
  'characterHud.npcFoe': 'враг',
  'characterHud.npcEnemy': 'враг',
  'characterHud.close': 'Закрыть',
  'characterHud.hpTemp': 'врем',
  'characterHud.level': 'Ур.',
  'characterHud.storeCorrupted': 'Данные персонажа повреждены. Загружен персонаж по умолчанию.',

  // === Builder Mode (066 phase-4) ===
  'characterHud.builder.stepIdentity': 'Персонаж',
  'characterHud.builder.stepRace': 'Раса',
  'characterHud.builder.stepClass': 'Класс',
  'characterHud.builder.stepStats': 'Характеристики',
  'characterHud.builder.stepBackground': 'Предыстория',
  'characterHud.builder.stepSkills': 'Навыки',
  'characterHud.builder.stepReview': 'Обзор',
  'characterHud.builder.alignLG': 'Законно-добрый',
  'characterHud.builder.alignNG': 'Нейтрально-добрый',
  'characterHud.builder.alignCG': 'Хаотично-добрый',
  'characterHud.builder.alignLN': 'Законно-нейтральный',
  'characterHud.builder.alignN': 'Нейтральный',
  'characterHud.builder.alignCN': 'Хаотично-нейтральный',
  'characterHud.builder.alignLE': 'Законно-злой',
  'characterHud.builder.alignNE': 'Нейтрально-злой',
  'characterHud.builder.alignCE': 'Хаотично-злой',
  'characterHud.builder.methodPointBuy': 'Покупка очков',
  'characterHud.builder.methodStandardArray': 'Стандартный массив',
  'characterHud.builder.methodManual': 'Ручной ввод',
  'characterHud.builder.identityTitle': 'Персонаж',
  'characterHud.builder.identitySubtitle': 'Основная информация о персонаже',
  'characterHud.builder.labelName': 'Имя персонажа',
  'characterHud.builder.labelGender': 'Пол',
  'characterHud.builder.labelAlignment': 'Мировоззрение',
  'characterHud.builder.placeholderName': 'Введите имя…',
  'characterHud.builder.raceTitle': 'Раса',
  'characterHud.builder.raceSubtitle': 'Выберите расу персонажа',
  'characterHud.builder.subraceLabel': 'Подраса',
  'characterHud.builder.raceSpeed': 'Скорость',
  'characterHud.builder.raceSize': 'Размер',
  'characterHud.builder.raceLanguages': 'Языки',
  'characterHud.builder.raceTraits': 'Особенности',
  'characterHud.builder.classTitle': 'Класс',
  'characterHud.builder.classSubtitle': 'Выберите класс персонажа',
  'characterHud.builder.classSaves': 'Спасброски',
  'characterHud.builder.classProficiencies': 'Владения',
  'characterHud.builder.classSkillChoices': 'Навыки: выбрать',
  'characterHud.builder.classHitDie': 'Кость хитов',
  'characterHud.builder.statsTitle': 'Характеристики',
  'characterHud.builder.statsSubtitle': 'Распределите значения характеристик',
  'characterHud.builder.budgetRemaining': 'Оставшиеся очки',
  'characterHud.builder.budgetDone': 'Все очки распределены ✓',
  'characterHud.builder.bgTitle': 'Предыстория',
  'characterHud.builder.bgSubtitle': 'Выберите предысторию персонажа',
  'characterHud.builder.bgSkills': 'Навыки',
  'characterHud.builder.bgFeature': 'Особенность',
  'characterHud.builder.skillsTitle': 'Навыки',
  'characterHud.builder.skillsSubtitle': 'Выберите навыки класса',
  'characterHud.builder.skillsCounter': 'Выбрано',
  'characterHud.builder.skillFromBg': '— предыстория',
  'characterHud.builder.skillFromRace': '— раса',
  'characterHud.builder.reviewTitle': 'Обзор',
  'characterHud.builder.reviewSubtitle': 'Проверьте данные персонажа',
  'characterHud.builder.reviewIdentity': 'Персонаж',
  'characterHud.builder.reviewStats': 'Характеристики',
  'characterHud.builder.reviewCombat': 'Боевые параметры',
  'characterHud.builder.reviewSkills': 'Навыки',
  'characterHud.builder.reviewProficiencies': 'Владения',
  'characterHud.builder.reviewSaves': 'Спасброски',
  'characterHud.builder.reviewErrors': 'Исправьте перед сохранением',
  'characterHud.builder.next': 'Далее',
  'characterHud.builder.prev': 'Назад',
  'characterHud.builder.save': '✓ Сохранить',
  'characterHud.builder.saved': 'Персонаж создан!',
  'characterHud.builder.previewPlaceholder': 'Начните заполнять персонажа',
  'characterHud.builder.previewSkills': 'Навыки',
  'characterHud.builder.previewProficiencies': 'Владения',
  'characterHud.builder.previewHp': 'ОЗ',
  'characterHud.builder.previewAc': 'КЗ',
  'characterHud.builder.previewSpeed': 'Скор',
  'characterHud.builder.errEmptyName': 'Имя персонажа обязательно',
  'characterHud.builder.errNoRace': 'Выберите расу',
  'characterHud.builder.errNoClass': 'Выберите класс',
  'characterHud.builder.errPointBuy': 'Распределите все 27 очков',
  'characterHud.builder.errStandardArray': 'Распределите все значения массива',
  'characterHud.builder.errManualRange': 'Значения характеристик: от 3 до 20',
  'characterHud.builder.errNoBackground': 'Выберите предысторию',
  'characterHud.builder.errSkillsUnder': 'Выберите ещё навыков',
  'characterHud.builder.errSkillsOver': 'Превышен лимит навыков класса',
  'characterHud.builder.confirmOverwrite': 'Создание нового персонажа заменит текущего. Данные отыгрыша, инвентарь и боевые настройки будут потеряны. Продолжить?',
  'characterHud.builder.confirmDiscard': 'У вас есть несохранённые изменения в мастере создания. Закрыть без сохранения?',
  'characterHud.builder.skillOverlap': 'Навык предыстории совпадает с навыком класса — вы получаете дополнительный выбор',

  // === Write Infrastructure (073) ===
  'characterHud.writeTimeout': 'Сервер не ответил, изменения могут быть потеряны',
  'characterHud.sheetDeleted': 'Лист персонажа был удалён',
  'characterHud.writeRejected': 'Изменение отклонено сервером',
  'characterHud.rollTimeout': 'Бросок не подтверждён сервером',
  'characterHud.restShort': 'Короткий отдых',
  'characterHud.restLong': 'Длинный отдых',
  'characterHud.deathSave': 'Спасбросок от смерти',
  'characterHud.deathDying': 'При смерти',
  'characterHud.deathStable': 'Стабилен',
  'characterHud.deathDead': 'Мёртв',
  'characterHud.deathSavesTally': 'Спасброски от смерти: успехи и провалы',
  'characterHud.hitDiceSpend': 'Использовать кость хитов',
  'characterHud.inspirationOn': 'Вдохновение получено',
  'characterHud.inspirationOff': 'Вдохновение потрачено',

  // === Character Mode (066 phase-2) ===
  'characterMode.navIdentity': 'Идентичность',
  'characterMode.navStats': 'Характеристики',
  'characterMode.navSkills': 'Навыки',
  'characterMode.navDefenses': 'Защиты',
  'characterMode.navAbilities': 'Способности',
  'characterMode.navSpells': 'Заклинания',
  'characterMode.navInventory': 'Снаряжение',
  'characterMode.navProficiencies': 'Владения',
  'characterMode.navProgression': 'Прогрессия',
  'characterMode.levelUp': 'Получить {N} уровень',
  'characterMode.passivePerception': 'Пасс. восприятие',
  'characterMode.passiveInvestigation': 'Пасс. анализ',
  'characterMode.passiveInsight': 'Пасс. проницательность',
  'characterMode.filterAll': 'Все',
  'characterMode.filterProficient': 'С владением',
  'characterMode.filterByAbility': 'По характеристике',
  'characterMode.breakdownTotal': 'Итого',
  'characterMode.breakdownStatMod': 'Модификатор {stat}',
  'characterMode.breakdownProficiency': 'Бонус мастерства',
  'characterMode.breakdownExpertise': 'Экспертиза (×2)',
  'characterMode.breakdownEffects': 'Эффекты',
  'characterMode.breakdownBase': 'База',
  'characterMode.spellDC': 'DC заклинаний',
  'characterMode.spellAttack': 'Бонус атаки',
  'characterMode.concentration': 'Концентрация',
  'characterMode.ritual': 'Ритуал',
  'characterMode.prepared': 'Подготовленные',
  'characterMode.known': 'Известные',
  'characterMode.cantrips': 'Заговоры',
  'characterMode.spellLevel': '{N} круг',
  'characterMode.noSpells': 'Заклинания недоступны',
  'characterMode.noFeatures': 'Нет способностей',
  'characterMode.noItems': 'Нет предметов',
  'characterMode.weight': 'Вес',
  'characterMode.currency': 'Валюта',
  'characterMode.equipped': 'Надето',
  'characterMode.attunement': 'Привязка',
  'characterMode.armor': 'Броня',
  'characterMode.weapons': 'Оружие',
  'characterMode.tools': 'Инструменты',
  'characterMode.languages': 'Языки',
  'characterMode.currentLevel': 'Текущий уровень',
  'characterMode.levelManualHint': 'Ручная правка: хиты/фичи не выдаются — для полного повышения жми «Повысить»',
  'characterMode.nextLevel': 'Следующий уровень',
  'characterMode.xpProgress': '{current} / {required} XP',
  'characterMode.resistances': 'Сопротивления',
  'characterMode.immunities': 'Иммунитеты',
  'characterMode.vulnerabilities': 'Уязвимости',
  'characterMode.conditions': 'Состояния',
  'characterMode.speeds': 'Скорости',
  'characterMode.senses': 'Сенсы',
  'characterMode.classFeatures': 'Класс',
  'characterMode.raceFeatures': 'Раса',
  'characterMode.feats': 'Фиты',
  'characterMode.allFeatures': 'Все',
  'characterMode.inspiration': 'Вдохновение',
  'characterMode.hitDice': 'Кость хитов',
  'characterMode.mockLevelUp': 'Повышение уровня (демо)',
  'characterMode.search': 'Поиск...',
  'characterMode.proficiencyBonus': 'БМ',
  'characterMode.walkSpeed': 'Шаг',
  'characterMode.unitFt': 'фт.',
  'characterMode.unitLbs': 'фн.',
  'characterMode.unitGp': 'зм',
  'characterMode.armorClass': 'Класс брони',
  'characterMode.castingTime': 'Время каста',
  'characterMode.range': 'Дистанция',
  'characterMode.castSpell': 'Использовать {name}',
  'characterMode.slotAriaLabel': 'Слот {level} круга: {current} из {max} доступно',
  'characterMode.useAriaLabel': 'Использование {i} из {max}, {status}',
  'characterMode.available': 'доступно',
  'characterMode.spent': 'потрачено',
  'characterMode.shortRest': 'КО',
  'characterMode.longRest': 'ДО',
  'characterMode.asiOrFeat': 'Повышение характеристик / Фит',
  'characterMode.attunementSlot': 'Слот привязки',
  'characterMode.attunementFilled': 'занят',
  'characterMode.attunementEmpty': 'свободен',
  'characterMode.bdModifier': 'модификатор',
  'characterMode.bdValue': 'Значение',
  'characterMode.bdSave': 'спасбросок',
  'characterMode.bdMod': 'Мод.',
  'characterMode.bdProficiency': 'владение',
  'characterMode.bdExpertise': 'экспертиза',
  'characterMode.bdPassive': 'пассивное',
  'characterMode.bdSkillMod': 'модификатор навыка',
  'characterMode.bdBaseAC': 'Базовый КЗ',
  'characterMode.bdShield': 'щит',
  'characterMode.bdItems': 'предметы',
  'characterMode.bdUnarmored': 'Без доспехов',
  'characterMode.bdArmor': 'Бонус доспеха',
  'characterMode.bdMiscAc': 'Прочий бонус',
  'characterMode.bdEffects': 'Эффекты',
  'characterMode.bdAttack': 'атака',
  'characterMode.bdStatMod': 'Мод. характеристики',
  'characterMode.bdSpellAttack': 'Бонус атаки заклинаниями',

  // === Character Mode: Stat short labels (i18n refactor T101) ===
  'characterMode.stat.str': 'СИЛ',
  'characterMode.stat.dex': 'ЛОВ',
  'characterMode.stat.con': 'ВЫН',
  'characterMode.stat.int': 'ИНТ',
  'characterMode.stat.wis': 'МДР',
  'characterMode.stat.cha': 'ХАР',
  'characterMode.saveAbbr': 'спас',
  'characterMode.saveProficiencyHint': 'Владение спасбросками этой характеристики',

  // === Character Mode: Skill labels (i18n refactor T101) ===
  'characterMode.skill.acrobatics': 'Акробатика',
  'characterMode.skill.animalHandling': 'Уход за животными',
  'characterMode.skill.arcana': 'Магия',
  'characterMode.skill.athletics': 'Атлетика',
  'characterMode.skill.deception': 'Обман',
  'characterMode.skill.history': 'История',
  'characterMode.skill.insight': 'Проницательность',
  'characterMode.skill.intimidation': 'Запугивание',
  'characterMode.skill.investigation': 'Расследование',
  'characterMode.skill.medicine': 'Медицина',
  'characterMode.skill.nature': 'Природа',
  'characterMode.skill.perception': 'Восприятие',
  'characterMode.skill.performance': 'Выступление',
  'characterMode.skill.persuasion': 'Убеждение',
  'characterMode.skill.religion': 'Религия',
  'characterMode.skill.sleightOfHand': 'Ловкость рук',
  'characterMode.skill.stealth': 'Скрытность',
  'characterMode.skill.survival': 'Выживание',

  // === Roleplay Mode (066 phase-3) ===
  'roleplay.boardTitle': 'Отыгрыш',
  'roleplay.boardSubtitle': 'Личность и история персонажа',
  'roleplay.cardHero': 'Герой',
  'roleplay.cardTriada': 'Характер',
  'roleplay.cardManners': 'Манеры',
  'roleplay.cardBackstory': 'Предыстория',
  'roleplay.cardGoals': 'Цели',
  'roleplay.cardNpc': 'Знакомые',
  'roleplay.cardFactions': 'Фракции',
  'roleplay.cardSessionLog': 'Журнал сессий',
  'roleplay.cardMoments': 'Ключевые моменты',
  'roleplay.catAll': 'Всё',
  'roleplay.catPersonality': 'Личность',
  'roleplay.catConnections': 'Связи',
  'roleplay.catPast': 'Прошлое',
  'roleplay.catPresent': 'Настоящее',
  'roleplay.catFuture': 'Будущее',
  'roleplay.tagPersonality': 'ЛИЧНОСТЬ',
  'roleplay.tagConnections': 'СВЯЗИ',
  'roleplay.tagPast': 'ПРОШЛОЕ',
  'roleplay.tagPresent': 'НАСТОЯЩЕЕ',
  'roleplay.tagFuture': 'БУДУЩЕЕ',
  'roleplay.done': 'Готово',
  'roleplay.doneEsc': 'Готово · esc',
  'roleplay.spanQuarter': '¼',
  'roleplay.spanThird': '⅓',
  'roleplay.spanHalf': '½',
  'roleplay.spanTwoThirds': '⅔',
  'roleplay.spanFull': 'полная',
  'roleplay.stylePlain': 'обыч',
  'roleplay.styleParchment': 'перг',
  'roleplay.styleDark': 'тёмн',
  'roleplay.addRow': '+ элемент',
  'roleplay.addGoal': '+ цель',
  'roleplay.addNpc': '+ NPC',
  'roleplay.addFaction': '+ фракция',
  'roleplay.addMoment': '+ момент',
  'roleplay.addSession': '+ сессия',
  'roleplay.duplicate': 'Дублировать',
  'roleplay.pin': 'Закрепить',
  'roleplay.unpin': 'Открепить',
  'roleplay.changeType': 'Сменить тип…',
  'roleplay.deleteCard': 'Удалить…',
  'roleplay.deleteConfirmTitle': 'Удалить карточку',
  'roleplay.deleteConfirmDesc': 'Удалить карточку «{title}»? Действие нельзя отменить.',
  'roleplay.changeTypeConfirm': 'Контент текущей карточки будет утерян. Продолжить?',
  'roleplay.momentPrologue': 'пролог',
  'roleplay.momentMinor': 'мелочь',
  'roleplay.momentEncounter': 'встреча',
  'roleplay.momentDilemma': 'сложный выбор',
  'roleplay.momentRevelation': 'откровение',
  'roleplay.momentTurning': 'поворот',
  'roleplay.momentFinale': 'финал арки',
  'roleplay.relAlly': 'союзник',
  'roleplay.relWarm': 'тепло',
  'roleplay.relNeutral': 'нейтрал',
  'roleplay.relEnemy': 'враг',
  'roleplay.searchPlaceholder': 'Поиск по карточкам…',
  'roleplay.autoLayout': '▭▭ авто',
  'roleplay.addCard': '+ карточка',
  'roleplay.addCardTitle': 'Новая карточка',
  'roleplay.addCardType': 'Тип',
  'roleplay.addCardContent': 'Содержимое',
  'roleplay.addCardSize': 'Размер',
  'roleplay.addCardStyle': 'Стиль',
  'roleplay.addCardSubmit': 'Добавить',
  'roleplay.addCardCancel': 'Отмена',
  'roleplay.addCardTitlePlaceholder': 'Заголовок карточки…',
  'roleplay.addCardContentPlaceholder': 'Содержимое…',
  'roleplay.editPlaceholder': 'Нажмите ✎ для редактирования',
  'roleplay.noResults': 'Ничего не найдено',
  'roleplay.labelIdeal': 'Идеал',
  'roleplay.labelBond': 'Связь',
  'roleplay.labelFlaw': 'Изъян',
  'roleplay.priorityArc': 'арка',
  'roleplay.prioritySession': 'сессия',
  'roleplay.sessionNumber': '#{n}',
  'roleplay.sessionLabel': 'сессия',
  'roleplay.placeholderTitle': 'Название...',
  'roleplay.placeholderSummary': 'Описание...',
  'roleplay.placeholderDescription': 'Описание...',
  'roleplay.placeholderName': 'Имя...',
  'roleplay.placeholderNotes': 'Заметки...',
  'roleplay.placeholderFaction': 'Фракция...',
  'roleplay.placeholderGoal': '...',
  'roleplay.dragToReorder': 'Перетащить для перемещения',
  'roleplay.editOptions': 'Опции редактирования карточки',
  'roleplay.removeGoal': 'Удалить цель',
  'roleplay.loyaltyLevel': 'Лояльность {n}',
  'roleplay.footerCount': '{n} записей',
};
